export default {
  pledgeLoanPendingReview: "في انتظار المراجعة",
  pledgeLoanOverdue: "متأخر",
  pledgeLoanName: "قرض بضمان",
  pledgeLoanInterest: "الفائدة",
  pledgeLoanMaturityDate: "تاريخ الاستحقاق",
  pledgeLoanHeroTitle: "استغل أصولك الرقمية إلى أقصى حد لتحقيق عوائد أكبر!",
  pledgeLoanCurrency: "العملة",
  pledgeLoanApplicationDate: "تاريخ الطلب",
  pledgeLoanCollateralTerm: "مدة الضمان",
  pledgeLoanHeroSubtitle: "فائدة الضمان صفر خلال الفترة الترويجية.",
  pledgeLoanRejected: "مرفوض",
  pledgeLoanBorrowAmount: "مبلغ القرض",
  pledgeLoanReviewDate: "تاريخ المراجعة",
  pledgeLoanWithdrawalWarning: "لديك أوامر قرض بضمان غير مسددة. يرجى تسويتها قبل التقدم بطلب السحب.",
  pledgeLoanRepayment: "السداد",
  pledgeLoanUnpayAmount: "المبلغ المستحق",
  pledgeLoanRepayTime: "وقت التسوية",
  pledgeLoanCollateralAmount: "مبلغ الضمان",
  pledgeLoanCollateralRatio: "نسبة الضمان",
  pledgeLoanInProgress: "قيد التنفيذ",
  pledgeLoanSettled: "مسوى",
  pledgeLoanApplyNow: "تقدم الآن",
  pledgeLoanFinishedText: "لا توجد بيانات أخرى",
  pledgeLoanPreviewOnly: "هذه معاينة فقط. لم يتم تقديم أي طلب.",
  required: 'الحقول المطلوبة',
  home: 'رئيسي',
  market: 'الأسواق',
  currency: 'تبادل',
  walletTrade: 'بقعة',
  contract: 'العقود الآجلة',
  wallet: 'أصول',
  pulling: 'للتحديث اسحب للأسفل...',
  loosing: 'إطلاق للتحديث...',
  loading: 'تحميل...',
  loadingError: 'فشل في التحميل',
  nothing: 'لايوجد بيانات',
  finished: '',
  price: 'سعر',
  number: 'كمية',
  recharge: 'إيداع',
  transfer: 'تحويل',
  invite: 'يدعو',
  inviteDes: 'دعوة الأصدقاء للانضمام إلينا',
  contact: 'اتصل بنا',
  contactDes: '7*24 اون لاين',
  fastTrade: 'خيارات',
  name: 'اسم',
  fastPrice: 'سعر',
  trend: '24H %',
  all: 'الجميع',
  growthList: 'الرابحون',
  loserList: 'الخاسرون',
  vol: '24 ساعة المجلد',
  buy: 'يشتري',
  sell: 'يبيع',
  optimal: 'سعر السوق',
  marketOrder: 'تجارة السوق',
  limitOrder: 'الحد من التجارة',
  useable: 'متاح',
  tradeVol: 'كمية',
  entrust: 'طلب محدود',
  entrustTotal: 'كمية',
  noLogin: 'تسجيل خروج,',
  toLogin: 'تسجيل الدخول الآن',
  cancelOrder: 'يلغي',
  cancelError: 'فشل الإلغاء',
  cancelSuccess: 'تم الإلغاء بنجاح',
  cancelTip: 'متأكد من الإلغاء؟',
  completed: 'مكتمل',
  canceled: 'Cancألغيتelled',
  marketPrice: 'سوق',
  limitPrice: 'حد',
  entrustPrice: 'سعر',
  entrustNum: 'كمية',
  currencyType: 'رمز',
  currencyOrder: 'سجل التجارة',
  history: 'تاريخ',
  tryAgain: 'حاول ثانية',
  entrustPriceTip: 'سعر الإدخال',
  tradeNumTip: 'كمية الإدخال',
  tradeNumLess: 'يجب أن تكون الكمية أكثر من 0',
  numLessTip: 'رصيد غير كاف',
  tradePriceTip: 'كمية الإدخال',
  balanceTip: 'رصيد غير كاف',
  tradeError: 'فشل في التجارة',
  tradeSuccess: 'التجارة بنجاح',
  tip: 'يلاحظ',
  tradeConfirm: 'تأكيد التداول？',
  cancelText: 'يلغي',
  confirmText: 'يتأكد',
  toBuy: 'يشتري',
  toSell: 'قصير',
  confirmToBuy: 'يشتري',
  confirmToSell: 'قصير',
  slPrice: 'سعر وقف الخسارة',
  sl: 'إيقاف الخسارة',
  tp: 'اخذ ربح',
  tpPrice: 'سعر جني الأرباح',
  currentOrder: 'النظام الحالي',
  historyOrder: 'تاريخ',
  setting: 'تعيين',
  unwind: 'يغلق',
  handUnwind: 'إغلاق يدويا',
  futuresPay: '',
  forceUnwind: 'تصفية',
  slTp: 'وقف الخسارة/جني الأرباح',
  fastTradeUnwind: 'خيارات',
  blowUp: 'تصفية',
  openNum: 'كمية',
  warrant: 'هامِش',
  openPrice: 'سعر',
  fee: 'مصاريف',
  profit: 'ربح',
  lastPrice: 'السعر الحالي',
  unwindPrice: 'سعر مغلق',
  unwindError: 'فشل في الإغلاق',
  unwindSuccess: 'تم الإغلاق بنجاح',
  setSuccess: 'تم التعيين بنجاح',
  setError: 'فشل الضبط',
  setSlTp: 'تعيين وقف الخسارة / جني الأرباح',
  second: 'ثانية',
  multiple: 'عديد',
  direction: 'يكتب',
  tradeCurrency: 'رمز',
  loss: 'خسارة',
  fill: 'يفوز',
  executePrice: 'سعر',
  currentPrice: 'السعر الحالي',
  closePrice: 'سعر مغلق',
  secondNum: 'دورة',
  contractOrder: 'أوامر العقود الآجلة',
  fastTradeOrder: 'أوامر الخيارات',
  overview: 'ملخص',
  ieoBuy: 'ما قبل البيع',
  balanceTotal: 'إجمالي الأصول',
  withdraw: 'ينسحب',
  tradeOrder: 'أمر التجارة',
  rechargeHistory: 'سجل الإيداع',
  withdrawHistory: 'سجل السحب',
  freeze: 'تجميد',
  amountTo: '',
  tipText: 'يلاحظ',
  ieoTip: 'انها قادمة قريبا.',
  financeList: 'سجل المالي',
  currencyAccount: 'حساب التمويل',
  contractAccount: 'حساب العقود الآجلة',
  time: 'وقت',
  status: 'حالة',
  balanceTyle: 'حساب',
  pay: 'حصيلة',
  income: 'دخل',
  lastBalance: 'توازن',
  orderNo: 'ID',
  money: 'كمية',
  date: 'تاريخ',
  finallyIncome: 'استلام المبلغ',
  commitMoney: 'كمية',
  orderNum: 'ID',
  waitReview: 'ليتم تأكيدها',
  reviewPass: 'اجتاز',
  reviewReject: 'مرفوض',
  waitWallet: 'مراجعة',
  walletPass: 'اجتاز',
  walletReject: 'مرفوض',
  withdrawSuccess: 'تم السحب بنجاح',
  withdrawError: 'فشل النقل',
  high24H: '24 High',
  low24H: '24H Low',
  num24H: '24H Vol',
  minute: 'دقائق',
  hour: 'ساعات',
  day: 'يوم',
  week: 'أسبوع',
  markets: 'سوق',
  open: 'سعر الفتح',
  close: 'سعر الإغلاق',
  high: 'اغلى سعر',
  low: 'أقل سعر',
  volume: 'Vol',
  fastLogin: 'تسجيل الدخول الآن',
  register: 'اشتراك',
  auth: 'يؤكد',
  authSuccess: 'تم التحقق',
  noPass: 'مرفوض',
  authCommit: 'مراجعة',
  onAuth: 'لم يتم التحقق منها',
  onLogin: 'تسجيل خروج',
  securitySet: 'حماية',
  userAgree: 'دعم المستخدمين',
  aboutUs: 'معلومات عنا',
  logout: 'تسجيل خروج',
  logoutSuccess: 'تم تسجيل الخروج بنجاح',
  lookAuthInfo: 'تحقق من المعلومات الخاصة بي',
  authAgain: 'إعادة التحقق',
  authInfo: 'معلومة',
  account: 'حساب',
  countryArea: 'البلد/المنطقة',
  idNo: 'ID#',
  idNoTip: 'رقم هوية الإدخال',
  email: 'بريد إلكتروني',
  emailInput: 'إدخال البريد الإلكتروني',
  setLoginPwd: 'تعيين كلمة مرور تسجيل الدخول',
  loginPwdInput: 'إدخال كلمة مرور تسجيل الدخول (8-20 حرفًا)',
  loginPwdTip: 'إدخال كلمة المرور لتسجيل الدخول',
  loginPwdLen: 'يجب أن تكون كلمة المرور لتسجيل الدخول من 8 إلى 20 حرفًا',
  setFinancePwd: 'تعيين كلمة مرور الصندوق',
  financePwdInput: 'كلمة مرور صندوق الإدخال (6-20 حرفًا)',
  financePwdTip: 'إدخال كلمة المرور للصندوق',
  financePwdLen: 'يجب أن تكون كلمة مرور الصندوق من 6 إلى 20 حرفًا',
  inviteCode: 'شفرة الدعوة',
  inviteCodeTip: 'إدخال رمز الدعوة',
  inviteInput: 'رمز الدعوة مطلوب',
  imageCode: 'كلمة التحقق',
  imageCodeInput: 'إدخال كلمة التحقق',
  agree: '《اتفاقية المستخدم》',
  agreeText: 'اتفاقية المستخدمين',
  next: 'التالي',
  registerSuccess: 'التسجيل كاملا',
  registerError: 'فشل في تسجيل',
 securityCheck: 'حماية',
googleAuthenticator: `مُصادِق Google`,
googleAuthBoundTitle: `تم تفعيل مُصادِق Google لهذا الحساب.`,
googleAuthBoundDesc: `يوفر مُصادِق Google حماية إضافية لحسابك.`,
googleAuthEnableTitle: `تفعيل مُصادِق Google`,
googleAuthEnableDesc: `أضف طبقة إضافية من الحماية إلى حسابك.`,
googleAuthScanTip: `امسح رمز QR باستخدام مُصادِق Google، ثم أدخل الرمز المكوّن من 6 أرقام.`,
googleAuthConfirm: `تأكيد الربط`,
googleAuthCodeTitle: `التحقق عبر Google`,
googleAuthCodeDesc: `أدخل الرمز المكوّن من 6 أرقام من مُصادِق Google.`,
googleAuthCodeInput: `أدخل رمز التحقق من Google`,
googleAuthBindSuccess: `تم تفعيل مُصادِق Google`,
googleAuthLoadError: `تعذر تحميل مُصادِق Google`,
  checkCodeInput: 'إدخال رمز التحقق',
  sendCheckCode: 'يرسل',
  sendSuccess: 'مرسل',
  sendError: 'فشل فى الارسال',
  welcome: 'مرحبا بك في',
  loginEmail: 'بريد إلكتروني',
  loginEmailInput: 'إدخال عنوان البريد الإلكتروني',
  loginPwd: 'كلمة سر الدخول',
  login: 'تسجيل الدخول',
  forgetPwd: 'هل نسيت كلمة السر',
  loginTip: 'تسجيل الدخول يعني موافقتك',
  loginSuccess: 'تسجيل الدخول بشكل كامل',
  loginError: 'فشل في تسجيل الدخول',
  fullname: 'اسم',
  country: 'البلد/المنطقة',
  countryTip: 'إدخال البلد/المنطقة',
  imgFront: 'قم بتحميل صورة للجزء الأمامي من بطاقة هويتك',
  imgReverse: 'قم بتحميل صورة للجزء الخلفي من بطاقة هويتك',
  commit: 'يُقدِّم',
  commitSuccess: 'تقديم بالكامل',
  commitError: 'فشل الإرسال',
  selectCurrency: 'اختر التشفير',
  rechargeNet: 'شبكة',
  rechargeAddress: 'عنوان الإيداع',
  copyAddress: 'انسخ العنوان',
  minRecharge: 'الحد الأدنى لمبلغ الإيداع',
  copySuccess: 'نسخ تماما',
  copyError: 'فشل النسخ',
  withdrawTip: 'يمكنك السحب بعد التحقق من حسابك',
  withdrawAddress: 'عنوان السحب',
  withdrawAddressInput: 'إدخال عنوان السحب',
  withdrawNet: 'شبكة',
  withdrawNum: 'كمية',
  withdrawNumInput: 'كمية الإدخال',
  withdrawNumLess: 'رصيد غير كاف',
  withdrawMin: 'الحد الأدنى لمبلغ السحب',
  balanceUse: 'متاح',
  actualMoney: 'استلام المبلغ',
  actualMoneyText: 'استلام المبلغ',
  financePwd: 'كلمة مرور الصندوق',
  trade: '',
  withdrawFail: 'فشل في الانسحاب',
  commitTime: 'تاريخ',
  from: 'From',
  to: 'To',
  transferMoney: 'كمية الإدخال',
  transferSuccess: 'نقل تماما',
  transferError: 'فشل النقل',
  transferHistory: 'سجل النقل',
  updateFinancePwd: 'تغيير كلمة مرور الصندوق',
  confirmPwd: 'تأكيد كلمة المرور',
  confirmPwdInput: 'إدخال تأكيد كلمة المرور',
  updatePwd: 'تغيير كلمة المرور',
  updatePwdSuccess: 'التغيير تماما',
  updatePwdError: 'فشل في التغيير',
  noAlike: 'كلمة المرور غير متناسقة',
  emailUpdate: 'تغيير الايميل',
  loginPwdUpdate: 'تغيير كلمة المرور لتسجيل الدخول',
  financePwdUpdate: 'تغيير كلمة مرور الصندوق',
  newEmail: 'بريد إلكتروني جديد',
  emailUpdateTip: 'إدخال بريد إلكتروني جديد',
  checkEmail: 'التحقق من البريد الإلكتروني',
  updateEmail: 'تغيير الايميل',
  updateEmailError: 'فشل في التغيير',
  updateEmailSuccess: 'التغيير تماما',
  checkError: 'أخفق التحقق',
  pwdLen: '8-20 حرفا',
  inviteUrl: 'رابط الإحالة',
  myInviteCode: 'شفرة الدعوة',
  fastInvite: 'ادعو الآن',
  myInvite: 'قائمة المدعوين',
  registerTime: 'تاريخ',
  bulletin: 'إعلان',
  inviteFriend: 'ادعو أصدقاء',
  saveAccount: 'حفظ الحساب وكلمة المرور',
  indicator: 'المؤشرات',
  type: 'يكتب',
  amount: 'كمية',
  retrievePwd: 'إعادة تعيين كلمة المرور',
  order: 'طلباتي', 
  registerTitle: 'تسجيل الحساب', 
  emailCheck: 'رمز التحقق من البريد الإلكتروني', 
  haveAccount: 'هل لديك حساب؟', 
  registerTip: 'لقد قرأت ووافقت على ', 
  userInfo: 'معلومات شخصية', 
  userAuth: 'التحقق من الحساب', 
  footerTip: 'حق التفسير النهائي ينتمي إلى المنصة', 
  marketInfo: 'الأسواق', 
  viewMore: 'انقر للعثور على المزيد', 
  tradeText: 'تجارة', 
  position: 'عائق', 
  level: 'مستوى', 
  oneBuy: 'يشتري', 
  oneSell: 'يبيع', 
  newTrade: 'في الوقت الحالى',
  tradePair: 'رمز', 
  historyEntrust: 'تاريخ الطلبات', 
  allOrder: 'كل سجل', 
  total: 'المجموع', 
  oneOrder: 'طلبات', 
  priceTip: 'سعر الإدخال', 
  numberTip: 'كمية الإدخال', 
  profitText: 'ربح', 
  foundInput: 'كمية الإدخال', 
  foundTip: 'الرجاء إدخال المبلغ', 
  countdown: 'العد التنازلي', 
  tradeMoney: 'كمية', 
  completePrice: 'سعر', 
  profitAndLoss: 'الربح والخسارة المقدرة', 
  walletOverview: 'نظرة عامة على الأصول', 
  ieoBuyAccount: 'حساب ما قبل البيع', 
  balanceText: 'تاريخ', 
  selectRechargeAddress: 'حدد عنوان الإيداع', 
  successText: 'نجاح', 
  errorText: 'يفشل', 
  selectWithdrawAddress: 'إدخال عنوان السحب', 
  withdrawSuText: 'أرسل بنجاح', 
  transferMoneyLabel: 'كمية', 
  paramsError: 'خطأ في المعلمة', 
  reset: 'إعادة ضبط', 
  selectText: 'يبحث', 
  emailManage: 'إدارة الحساب', 
  loginPwdDes: 'تعديل كلمة مرور تسجيل الدخول الخاصة بك', 
  updateText: 'يُعدِّل', 
  financePwdDes: 'تعديل كلمة مرور الصندوق الخاص بك', 
  emailManageDes: 'حافظ على أمان حسابك', 
  oldEmail: 'عنوان البريد الإلكتروني الأصلي', 
  countryAreaTip: 'إدخال البلد أو المنطقة',  
  fullnameTip: 'اسم الإدخال',
  agreeTip: 'يرجى التحقق من "اتفاقية المستخدمين"',
  volume24h: '24H Vol',
  // 首页
  currencyHomeType: 'رمز',
  whyUs: 'لماذا نحن؟',
  why1: 'مؤمن ومؤمن',
  why1Des: 'نقوم بتخزين 80% من العملات المشفرة في محفظتنا الباردة الآمنة. يتم تأمين وتأمين مخازن التبريد بواسطة دفتر الأستاذ.',
  why2: 'المعاملات السريعة',
  why2Des: 'يمكننا التعامل مع ملايين المعاملات. يمكن توسيع البنية التحتية لنظامنا في بضع ثوانٍ لتتناسب مع الطلب المتزايد.',
  why3: 'بسيطة وسهلة الاستخدام',
  why3Des: 'يعد التداول على منصتنا تجربة فائقة السرعة. لقد قمنا ببناء التكنولوجيا التي يستخدمها الملايين، وقد ساعدتنا هذه التجربة في بناء هذا التبادل القوي.',
  why4: 'التداول الفوري',
  why4Des: 'تداول فوريًا بأكثر من 150 عملة مشفرة بنقرة واحدة.',
  why5: 'افضل سعر',
  why5Des: 'تداول جميع العملات المشفرة بسيولة عالية.',
  why6: 'يثق',
  why6Des: 'أكثر من 800000+ مستخدم لديهم الإيمان وقاموا بالتداول بمئات الملايين.',
  homeGift: 'احصل مجانًا على 30 دولارًا للتداول للحصول على مكافأة التسجيل.',
  popular1: '100,000 دولار أمريكي+',
  popular1Des: 'إجمالي حجم التداول',
  popular2: '150+',
  popular2Des: 'العملات المدعومة',
  popular3: '800K+',
  popular3Des: 'المستخدمون الذين تم التحقق منهم',
  globalText: 'موثوق به من قبل أكثر من 800000 مستخدم عالميًا لتداول العملات المشفرة',
  startText: 'ابدأ في 5 دقائق فقط.',
  start1: 'اشتراك',
  start1Des: 'افتح موقع الويب أو قم بتنزيل التطبيق، وقم بالتسجيل باستخدام البريد الإلكتروني.',
  start2: 'KYC',
  start2Des: 'احتفظ بإثبات هويتك في متناول يدك، وأدخل تفاصيل KYC الأساسية وقم بالتحقق من حسابك.',
  start3: 'إيداع',
  start3Des: 'قم بالإيداع بسهولة في محفظتك الرقمية.',
  start4: 'شراء بيع',
  start4Des: 'شراء/بيع وتداول العملات المشفرة بأفضل الأسعار.',
  secondTip: 'يجب ألا يقل المبلغ عن{tip}',
  appTitle: 'التطبيق متاح الآن',
  appDes: 'احصل على الأمان والتداول والإمكانيات التي توفرها منصة تبادل العملات المشفرة الأفضل في فئتها، مباشرةً على هاتفك الذكي.',
  timeUp: 'انتهى الوقت',
  closeAll: 'إغلاق الكل',
  assetRate: 'معدل الهامش',
  cancel: 'يلغي',
  cancelInfo: 'تأكيد الإلغاء؟',
  buyCurrency: 'رمز',
  closeCurrency: 'عملة',
  buyPrice: 'سعر',
  valuation: 'تقييم',
  profitP: 'معدل العائد',
  buySuccess: 'بنجاح',

  swiperTitle1: 'أفضل بورصة تشفير رقمية في العالم',
  swiperSub1: 'موثوق به من قبل أكثر من 100.000 مستخدم',
  
  ieoBuying: 'جاري التنفيذ',
  ieoOpen: 'تاريخ البدء (UTC-5)',
  ieoClose: 'تاريخ الانتهاء(UTC-5)',
  about: 'عن',
  ieoPlan: 'توزيع',
  ieoInfo: 'معلومة',
  ieoContact: 'وسائل التواصل الاجتماعي',
  ieoStart: 'التهيئة',
  ieoBuyStart: 'بداية IEO',
  ieoBuyEnd: 'إنهاء IEO',
  ieoIsTrade: 'يطلق',
  introduce: 'مقدمة',
  ieoSubBuy: 'IEO',
  subBuyHistory: 'IEOتاريخ',
  createTeam: 'صندوق احتياطي',
  angelFund: 'صندوق الملاك',
  ecology: 'المؤسسات والنظم البيئية',
  presale: 'إصدار ما قبل البيع',
  mechanism: 'آلية التعدين',
  trading: 'تداول البورصة',

  issuePrice: 'سعر الإصدار',
  minBuyPrice: 'الحد الأدنى للاشتراك',
  buyNum: 'الاشتراكات في اليوم الواحد',
  buyTotal: 'إجمالي الاشتراك اليومي',
  Increment: 'زيادة الاشتراك',
  blockchain: 'بلوكتشين',

  sellTotal: 'إجمالي الإصدار',
  currentBuy: 'الاشتراك الحالي',
  dowload: 'مركز التحميل',
  lessMinTip: 'لا يمكن أن يكون أقل من الحد الأدنى للمبلغ.',
  rechargeTip1: '1. هذا هو عنوانك الجديد والفريد من نوعه، ولن تطلب منك المنصة أبدًا تحويل أموال إلى حساب آخر أو طلب رمز التحقق الخاص بك.',
  rechargeTip2: '2. يتطلب الإيداع ما لا يقل عن 10 كتل شبكية للتأكيد. بعد التأكيد، سيتلقى حسابك الأموال تلقائيًا.',
  withdrawTip1: '1. تأكد من تحديد نفس الشبكة لعملية السحب هذه مثل الشبكة الموجودة على جانب الإيداع، وتأكد من أن منصة الاستقبال تدعم الشبكة. وإلا فسوف تفقد الأصول الخاصة بك.',
  withdrawTip2: '2. ستؤكد عمليات حظر الشبكة انسحابك بعد موافقة النظام الأساسي على طلبك.',
  withdrawTip3: '3. يتطلب السحب ما لا يقل عن 10 كتل للشبكة للتأكيد. بعد التأكيد، سيتلقى حسابك الأموال تلقائيًا.',
  footerBottomTip: 'المعلومات المقدمة في هذا الموقع لا تشكل نصيحة استثمارية أو نصيحة مالية أو نصيحة تجارية أو أي نوع آخر من النصائح ويجب ألا تتعامل مع أي من محتوى الموقع على هذا النحو. تتميز استثمارات العملات المشفرة بطبيعتها بأنها متقلبة وعالية المخاطر. لا تستثمر أكثر مما تستطيع أن تخسره.',

  seedSell: 'جولة البذور',
  privateSell: 'جولة خاصة',
  openSell: 'جولة كول',
  ieoAward: 'الجولة العامة',
  ieoGrowUp: 'فريق',
  partner: 'المستشارين',
  consultant: 'تسويق',
  ieoName: 'السيولة',
  conAward: 'الذكاء الاصطناعي لكسب',
  staking: 'التوقيع المساحي',

  stakeAccount: 'حساب التوقيع المساحي',
  serviceAccount: 'حساب الخدمة',
  lock: 'قفل',
  lockPrice: 'سعر مغلق',
  ieoHistory: 'تاريخ المنظمة الأوروبية للتقييم',
  lockHistory: 'قفل التاريخ',
  sellHistory: 'بيع التاريخ',
  stake: 'التوقيع المساحي',
  service: 'خدمة',
  ieoBuyTip: "*IEO Notice: The number of GPTH is limited. We will review the user's IEO application and draw lots randomly every 3 hours. Users with a relatively large amount will have a higher probability of buying GPTH. Each user can buy up to 3 times per day.",
  ieoLockTip: '*Lock Price: Users need to use USDT as the pledge currency to lock the price of GPTH, and the pledge ratio is 30% of the value of GPTH. After GPTH is launched, users can sell GPTH at the price locked at that time.',
  ieoSellTip: '*IEO Selling: Selling GPTH requires 10% of the GPTH value as a service fee. After selling GPTH, the USDT you exchanged will be unfrozen in 20 days, and the pledged USDT will be unfrozen in 20 days.',
  whitePaper: 'ورق ابيض',
  cost: 'يكلف',
  currentEstimate: 'التقييم الحالي',
  stakeNum: 'مبلغ التوقيع المساحي',
  estimate: 'تقييم',
  consume: 'تستهلك',
  release: 'يطلق',
  closedTime: 'وقت مغلق',
  remark: 'ملاحظة',


  totalProfit: 'اجمالي الربح',
  transferIn: 'نقل في',
  transferOut: 'انقله خارجا',
  equity: 'عدالة',

  emailaddress: 'عنوان البريد الإلكتروني',
  
  homeremind1: 'العملات المشفرة المشهورة',
  homeremind2: 'عرض المزيد من الأسواق',
  homeremind3: 'السعر الأخير (دولار أمريكي)',
  homeremind4: 'التغيير على مدار 24 ساعة',
  homeremind5: 'فعل',
  homeremind6: 'عرض المزيد',
  homeremind7: "أفضل اختيارات المستخدمين",
  homeremind8: 'حجم التداول على مدار 24 ساعة',
  homeremind9: 'الأصول الافتراضية الرئيسية',
  homeremind10: 'منتجاتنا الأساسية',
  homeremind11: 'مجموعة واسعة من أدوات التداول للاختيار من بينها',
  homeremind12: 'بقعة',
  homeremind13: 'أكثر من 700 عملة مشفرة متاحة للتداول',
  homeremind14: 'قم بترقية تجربتك من خلال تداول العقود الآجلة',
  homeremind15: 'FTZINC كسب',
  homeremind16: 'أفضل APYs في الصناعة',
  homeremind17: 'خدماتنا المتنوعة',
  homeremind18: 'اكتشف إمكانيات غير محدودة مع خدماتنا المتنوعة',
  homeremind19: 'اشتراك IEO',
  homeremind20: "أفضل العملات المشفرة قبل البيع",
  homeremind21: 'خدمات العملاء لكبار الشخصيات',
  homeremind22: '7*24 ساعة',
  homeremind23: 'مجتمع',
  homeremind24: 'اكتشف فرص الثروة هنا معنا',
  homeremind25: 'التجارة أثناء التنقل. في أي مكان وفي أي وقت.',
  homeremind26: 'ابق على اطلاع من خلال تطبيقنا وعميل سطح المكتب.',
  homeremind27: 'تابعنا على وسائل التواصل الإجتماعي',
  homeremind28: 'ابق على اطلاع بأحدث أخبارنا',
  homeremind29: 'التجارة في أي وقت وفي أي مكان',
  homeremind30: 'جرب FTZINC مع نظام التشغيل iOS، أو Android، أو واجهة برمجة التطبيقات (API).',


  ieoDes: `تهدف سلسلة تطبيقات الأصول الرقمية الذكية (DAS) إلى بناء منظومة تطبيقات ذكية للأصول الرقمية تعتمد على تقنية البلوك تشين، مما يُزيل عوائق تداول الأصول التقليدية.`,
  ieoDes1: `من خلال تجزئة الأصول الشخصية، تُوفر هذه السلسلة للمستخدمين خدمات تشغيل أصول متنوعة على السلسلة، مما يُمكّن من تمويل الأصول بكفاءة، وتحقيق القيمة المضافة، والرهن، والإقراض. يُساعد هذا المستخدمين على تحقيق عوائد ثابتة وكبيرة، ويُعزز الابتكار والتطوير والتطبيقات المتوافقة مع المعايير في قطاع الأصول الرقمية.`,

  ieoDes10: `مشروع "سلسلة الاحتياطي الذكي للطاقة البيئية" (ERS)، مشروعٌ مبتكرٌ قائمٌ على تقنية البلوك تشين، يدمج هذه التقنية لتلبية احتياجات احتياطيات الطاقة في النظام البيئي العالمي. يهدف المشروع بشكلٍ أساسي إلى حلّ تحديات أمن إمدادات الطاقة خلال فترات نقص الطاقة العالمي والأحداث الطارئة.`,
  ieoDes11: `يعتمد المشروع على فريقٍ أساسيٍّ مؤلفٍ من رواد الصناعة من دولٍ متعددة، لبناء منصةٍ ذكيةٍ لامركزيةٍ لاحتياطيات الطاقة في النظام البيئي. تربط هذه المنصة سلسلة صناعة الطاقة بأكملها، بما في ذلك البحث والتطوير، والتطبيق، والأمن، والنقل. ومن خلال نظامٍ اقتصاديٍّ قائمٍ على الرموز الرقمية، تُحفّز المنصة المشاركة في بناء النظام البيئي، محققةً بذلك التوزيع الذكي، والتخزين البيئي، والتداول العالمي لموارد الطاقة.`,
  ieoDes12: `يُصدر المشروع رمز ERS الرقميّ كرمزٍ حصريٍّ للنظام البيئي. ومن خلال التوزيع العلميّ للرموز الرقمية وخارطة طريقٍ واضحةٍ للإدراج، يُعزّز المشروع تنفيذه وتطوير النظام البيئي، مُقدّماً حلاً قائماً على تقنية البلوك تشين لأمن الطاقة العالمي.`,

  foundingTeam: 'الفريق المؤسس',
  managementTeam: 'فريق الإدارة',
  investors: 'المستثمرين',
  ecologicalFund: 'الصندوق البيئي',
  presaleNew: 'ما قبل البيع',
  stakingNew: 'التوقيع المساحي',
  publicTrading: 'التجارة العامة',

  aboutName: 'حول FTZINC',
  aboutContent: `<p><strong>FTZINC اليوم</strong></p><p> </p><p>اليوم، أصبحت FTZINC شركة عالمية لها مكاتب في الولايات المتحدة الأمريكية، وبريطانيا، وأستراليا، وقبرص، وجبل طارق، وبولندا، وبلغاريا، وسيشل. في فترة وجيزة، أصبحنا إحدى أسرع منصات التداول الاستثماري نموًا في أوروبا، محققين نموًا سنويًا بنسبة تفوق 100%، وفريقًا عالميًا نما خمسة أضعاف في عامين فقط.</p><p> </p><p>ولكن في جوهر كل ذلك، نحن شركة تُعنى بالأفراد. انطلاقًا من ثقافتنا الراسخة في التكنولوجيا والابتكار، أنشأنا منصة تُمكّن الأفراد من إطلاق العنان لإمكاناتهم الكاملة.</p><p> </p><p>مهما كان دافعك - سواءً كان تعلم مهارة جديدة، أو تنمية ثروتك، أو محاسبة الشركات على أفعالها - فنحن ملتزمون بمساعدتك على تحقيق أهدافك في التداول والاستثمار.</p><p> </p><p>ضع ثقتك في منصة تداول استثماري عالمية حائزة على جوائز متعددة، ومرخصة ومنظمة من قبل هيئة السلوك المالي في المملكة المتحدة، وهيئة الأوراق المالية والبورصات القبرصية، وهيئة الأوراق المالية والاستثمارات الأسترالية، وهيئة الخدمات المالية في سيشل، وهيئة الأوراق المالية في جزر البهاما. نعدكم بخدمة عملاء استثنائية على مدار الساعة طوال أيام الأسبوع، وأسعار شفافة بدون عمولة، وبدون رسوم خفية، ورسوم منخفضة لليلة واحدة، وفروق أسعار تنافسية.</p><p> </p><p><strong>رؤيتنا</strong></p><p>لعقود، كانت الخدمات المالية تُدار من قِبل الأغنياء ولأجل الأغنياء. أراد مؤسسو FTZINC تغيير هذا. كانت مهمتنا إحداث ثورة في عالم التمويل التقليدي لجعل التداول أكثر سهولة.</p><p>انطلقنا لمنح الناس إمكانية الوصول إلى الأسواق المالية. ومن هذه الفكرة البسيطة، انبثقت ثورة - ثورة قادها أناس عاديون، تولوا زمام الأمور وأحدثوا فرقًا في حياتهم ومستقبلهم المالي، والأهم من ذلك، مستقبل العالم.</p><p>لذلك، عندما بدأ مستثمرو التجزئة بالتجمع خلف تيسلا للمساعدة في إنشاء واحدة من أكثر الشركات قيمة في العالم، لم يكونوا يستثمرون فقط في سهم نمو بتقنية ثورية، بل كانوا يستثمرون في وعد بمستقبل أفضل - مستقبل أكثر استدامة. وبينما يلعب نشطاء المناخ والسياسيون دورهم، كان سعر سهم تيسلا السمة المميزة في صناعة سيارات تعمل بالكامل بالوقود الأحفوري وتتجه نحو الكهرباء. لطالما كانت FTZINC حاضرةً بقوة، داعمةً ورائدةً لثورة مستثمري التجزئة. منذ انطلاقها عام ٢٠١٦، سخّرنا قوة التكنولوجيا لفتح خيارات التداول والاستثمار، بطريقةٍ تُزيل عوائق الدخول التقليدية والبالية. واليوم، تدعم منصتنا العالمية، القائمة على الويب والتطبيق، أكثر من ٤ ملايين متداول في سعيهم لإحداث فرقٍ إيجابي في حياتهم ومستقبلهم المالي والعالم.</p><p><br></p>`,
  
  detailName0: 'إيداع',
  detailName1: 'ينسحب',
  detailName2: 'تجميد',
  detailName3: 'قم بإلغاء التجميد',
  detailName4: 'تجارة السوق الفورية',
  detailName5: 'التجارة ذات الحدود الفورية',
  detailName6: 'تجارة العقود في السوق',
  detailName7: 'التجارة بحدود العقد',
  detailName8: 'العقد مغلق',
  detailName9: 'IEO',
  detailName10: 'إيداع',
  detailName11: 'تجميد - سحب',
  detailName12: 'إنقاص-سحب',
  detailName13: 'تم رفض سحب الأموال',
  detailName14: 'تحويل',
  detailName15: 'تم فتح العقد',
  detailName16: 'تصفية',
  detailName17: 'تم إلغاء سحب الاسترداد',
  detailName19: 'تجميد القرض بضمان',
  detailName20: 'تم رفض القرض بضمان',
  detailName21: 'القرض بضمان',
  detailName22: 'سداد القرض بضمان',
  detailName23: 'تمت تسوية القرض بضمان',


  usersAgreementsTitle: 'اتفاقيات المستخدمين',
  usersAgreements: `<p><strong>1. يتم توفير FTZINC لعشاق تداول أصول سلسلة الكتل العالمية. لقد نصت هذه الاتفاقية على الشروط التي لها أو قد تكون لها علاقة هامة بحقوقك ومصالحك، والشروط التي تحتويها المنصة أو قد يكون لها إعفاء أو تحديد للمسؤولية، يرجى الانتباه. أنت تؤكد أنه قبل التسجيل كمستخدم لهذه المنصة لقبول هذه الخدمة، فإنك قد قرأت وفهمت وقبلت جميع محتويات هذه الاتفاقية بالكامل. بمجرد استخدامك لهذه الخدمة، فإنك توافق على اتباع جميع أحكام هذه الاتفاقية.</strong></p><p><strong>2. أنت توافق على أن هذه المنصة لها الحق في تغيير محتوى هذه الاتفاقية من جانب واحد في أي وقت، وتحديثها وعرضها على صفحة اتفاقية الخدمة دون إشعار منفصل لك؛ إذا واصلت استخدام الخدمة بعد الإعلان عن تغييرات محتوى هذه الاتفاقية، فهذا يعني أنك قرأت محتوى الاتفاقية المعدلة وفهمته وقبلته بالكامل، وسوف تستخدم الخدمة وفقًا لمحتوى الاتفاقية المعدلة ; إذا كنت لا توافق على محتوى الاتفاقية المعدلة، فيجب عليك التوقف عن استخدام الخدمة.</strong></p><p><strong>3. أنت تضمن أنه عند موافقتك على قبول هذه الاتفاقية والتسجيل كمستخدم لهذه المنصة، فإنك قد بلغت سن 18 عامًا؛ لا يتم استبعاد محتوى هذه الاتفاقية بموجب قوانين بلدك أو منطقتك. وفي حالة عدم استيفاء الشروط المذكورة أعلاه، يجب عليك إنهاء التسجيل فورًا أو التوقف عن استخدام الخدمة.</strong></p><p><strong>1. قيود استخدام الحساب</strong></p><p><strong>1.1 عند استخدام هذه الخدمة، يجب عليك الالتزام بقوانين ولوائح بلدك أو منطقتك والممارسات الدولية ذات الصلة، وعدم استخدام هذه الخدمة لأي غرض غير قانوني (بما في ذلك حظر أو تقييد معاملة العناصر التجارية)، ولا في أي غرض آخر. طريقة غير قانونية استخدم هذه الخدمة.</strong></p><p><strong>1.2 يجب ألا تستخدم هذه الخدمة للانخراط في أعمال تنتهك الحقوق والمصالح المشروعة للآخرين، وإلا فإن هذه المنصة لها الحق في التحقيق أو تأخير أو رفض التسوية أو رفض تقديم هذه الخدمة، ويجب عليك أن تتحمل بشكل مستقل كل ما يتعلق بذلك المسؤوليات القانونية، وبالتالي تسبب هذه المنصة أو هذه المنصة إذا أصيب أحد الموظفين، فستكون مسؤولاً عن التعويض.</strong></p><p><strong>تشمل الإجراءات المذكورة أعلاه، على سبيل المثال لا الحصر، ما يلي:</strong></p><p><strong>أ. انتهاك الحقوق والمصالح المشروعة للآخرين، مثل السمعة والخصوصية والأسرار التجارية.</strong></p><p><strong>ب. انتهاك التزامات السرية المنصوص عليها أو المتفق عليها قانونا.</strong></p><p><strong>ج. استخدام الخدمة باسم الآخرين.</strong></p><p><strong>د. الانخراط في معاملات غير قانونية، مثل غسيل الأموال أو تمويل الإرهاب أو تجارة المخدرات أو غيرها من المواقف التي تعتقد فيها المنصة أنه لا ينبغي استخدام الخدمة.</strong></p><p><strong>ه. المشاركة في أي سلوك قد يحتوي على فيروسات حاسوبية أو قد ينتهك نظام الخدمة وبياناتها.</strong></p><p><strong>F. إجراء معاملات لا تتفق مع محتوى المعاملة المعلن عنها من قبلك أو من قبل الطرف المقابل، أو المعاملات غير الصحيحة.</strong></p><p><strong>ز. الإجراءات الأخرى التي تعتبرها هذه المنصة غير مناسبة لأسباب مشروعة.</strong></p><p><strong>2. خدمات الوساطة FTZINC</strong></p><p><strong>الذي يحتوي على:</strong></p><p><strong>2.1 الضمان: يمكنك إعادة شحن حساب FTZINC الخاص بك (بما في ذلك البيتكوين والأصول الرقمية الأخرى التي تدعمها هذه المنصة، كما هو موضح أدناه) باستخدام الطريقة المحددة بواسطة هذه الخدمة، وتكليف هذه المنصة بالاحتفاظ بها نيابة عنك.</strong></p><p><strong>2.2 التسوية: بالنسبة للمعاملات بينك وبين المستخدمين الآخرين على هذه المنصة، ستعمل المنصة كطرف ثالث لتقديم خدمات تسوية المعاملات للأصول الرقمية (لا تشمل العملات القانونية لمختلف البلدان). أنت توافق على أنه بعد التسوية على المنصة، يكون الدفع لا رجعة فيه ما لم يتم الاتفاق على ذلك في هذه الاتفاقية.</strong></p><p><strong>2.3 السحب: يمكنك أن تطلب من هذه المنصة دفع مبلغ أصولك الرقمية التي تعهدت إلى هذه المنصة بإدارتها. عند إرسال تعليمات سحب العملة إلى المنصة، يجب عليك التحقق من طريقة التحقق الصالحة التي حددتها على المنصة. ستتلقى المنصة تعليمات التحقق الناجحة خلال الوقت المحدد (يخضع على وجه التحديد للوائح المنصة)، والرقم المقابل يتم تحويل مبلغ الأصول إلى عنوان التسليم الفعلي الذي قدمته.</strong></p><p><strong>2.4 الاستعلام: يمكنك الاستعلام عن سجلات المعاملات تحت اسم حسابك في هذا النظام في الوقت الفعلي.</strong></p><p><strong>2.5 الأموال الحصرية: ستحتفظ المنصة بأسهم الأصول الرقمية التي دفعتها لهذه المنصة وتنتمي إلى حسابك، ولن تستخدمها لأي غرض آخر بخلاف تعليماتك.</strong></p><p><strong>3. المتعلقة بالتسجيل</strong></p><p><strong>يجب عليك التسجيل مباشرة في هذا الموقع والحصول على الحساب المقدم لك من خلال هذه المنصة. أنت توافق على:</strong></p><p><strong>3.1 تقديم معلومات التحقق بدقة وفقًا لمتطلبات النظام الأساسي وتحديث معلومات التحقق الصحيحة والأحدث والكاملة في الوقت المناسب بعد الحصول على الحساب. إذا كان لدى المنصة سبب لاستنتاج أن المعلومات التي قدمتها غير صحيحة أو غير محدثة أو غير كاملة، وتطلب المنصة منك تقديم أي معلومات ذات صلة، وإذا لم تتمكن من تقديمها في الوقت المناسب، فيحق لنا رفض طلبك. الوصول إلى هذا الموقع وإنهاء أو تعليق حسابك.</strong></p><p><strong>3.2 يجب عليك تقديم تحديث دقيق وفي الوقت المناسب لعنوان البريد الإلكتروني ومعلومات الاتصال الأخرى التي تقدمها، حتى تتمكن هذه المنصة من الاتصال بك في الوقت المناسب وبطريقة فعالة. ستكون وحدك المسؤول عن أي خسارة أو أي زيادة في التكاليف والعواقب السلبية الأخرى التي تتكبدها أثناء استخدام هذه الخدمة بسبب عدم القدرة على الاتصال بك من خلال طرق الاتصال هذه. أنت تفهم وتوافق على أنك ملزم بالحفاظ على صحة معلومات الاتصال التي تقدمها. إذا كان هناك تغيير يحتاج إلى التحديث، فيجب عليك العمل وفقًا لمتطلبات هذا النظام الأساسي.</strong></p><p><strong>3.3 يجب ألا يحتوي حسابك على معلومات مضللة أو احتيالية، بما في ذلك على سبيل المثال لا الحصر، استخدام معلومات مصادقة هوية شخص غير شخص، والحساب البنكي لشخص غير شخص، وما إلى ذلك.</strong></p><p><strong>3.4 نظرًا لأنك لم تقم بتحديث المعلومات في الوقت المناسب (بما في ذلك على سبيل المثال لا الحصر رقم الهاتف المحمول وعنوان البريد الإلكتروني وما إلى ذلك المرتبط بحساب هذه المنصة)، لا يمكن تقديم الخدمة أو يحدث أي خطأ عند تقديمها لا يجوز لك استخدام هذا كإلغاء للمعاملة أو رفض الدفع، وسوف تتحمل جميع العواقب الناشئة عن ذلك، ولا تتحمل هذه المنصة أي مسؤولية.</strong></p><p><strong>3.5 أنت مسؤول عن حسابك، ويمكنك وحدك استخدام حسابك.</strong></p><p><strong>3.6 أنت توافق على أنه إذا فقدت كل أو جزء من أهليتك المتعلقة بالحقوق المدنية أو السلوك المدني، فإن لهذه المنصة الحق في التصرف في الأموال المتعلقة بحسابك وفقًا لمستندات قانونية صالحة (بما في ذلك على سبيل المثال لا الحصر، أحكام المحكمة النافذة، الوصية الفعالة، الخ.) المادة.</strong></p><p><strong>3.7 يمكننا أن نطلب منك إكمال عملية التحقق من الهوية في أي وقت، وقد نطلب منك أيضًا تقديم مستندات هوية إضافية إلى هذه المنصة إذا اعتقدنا أن ذلك ضروري. سيتم اعتبار الفشل في إكمال التحقق من الهوية انتهاكًا لهذه الاتفاقية.</strong></p><p><strong>3.8 يجوز لنا إغلاق أو تعليق أو تقييد وصولك إلى حسابك أو الخدمات الأخرى التي نقدمها، و/أو تقييد استخدام رصيد الأصول الرقمية الخاص بك لمدة 180 يومًا (أو أكثر، إذا كان ذلك وفقًا لأوامر المحكمة أو الإجراءات القانونية الأخرى) إذا انتهكت شروط الخدمة هذه أو أي اتفاقية أخرى. عند تقييم المخاطر المرتبطة بحسابك، يمكننا أيضًا استخدام نموذج تقييم المخاطر الخاص، ويُعتبر المستخدمون ذوو المخاطر العالية قد انتهكوا هذه الاتفاقية.</strong></p><p><strong>3.9 وفقًا لشروط هذه الاتفاقية، إذا قررنا أنك قد انتهكت هذه الاتفاقية أو أي اتفاقية أخرى في أي وقت سابق، فيمكننا أيضًا إغلاق أو تعليق أو تقييد استخدام حسابك ورصيد الأصول الرقمية الخاص بك للخدمة. الذي تستخدمه وغيرها من التدابير.</strong></p><p><strong>4. أمان الحساب</strong></p><p><strong>وستكون مسؤولاً مسؤولية كاملة عن جميع العمليات والخطابات باستخدام هذا الحساب وكلمة المرور. أنت توافق على:</strong></p><p><strong>4.1 يتعرف هذا النظام الأساسي على تعليماتك من خلال تعليمات مثل اسم تسجيل الدخول إلى حسابك وكلمة المرور. يجب عليك الاحتفاظ باسم تسجيل الدخول وكلمة المرور لحسابك بشكل صحيح، وستكون مسؤولاً عن الخسائر الناجمة عن الكشف عن كلمة المرور. أنت تتعهد بعدم الكشف عن اسم تسجيل الدخول وكلمة المرور الخاصين بحسابك لأي شخص آخر، أو استخدام اسم تسجيل الدخول وكلمة المرور الخاصين بأي شخص آخر. قد تستخدم هذه المنصة أيضًا هذه الخدمة لتطبيق منتجات أو معدات أخرى تستخدمها لتحديد تعليماتك. يجب عليك الاحتفاظ بهذه المنتجات أو المعدات بشكل صحيح تحت سيطرتك أو يجب أن تكون تحت سيطرتك. تقع على عاتقك مسؤولية أي خسارة ناجمة عن فقدان هذه المنتجات أو المعدات.</strong></p><p>4.2 أنت توافق على أنه (أ) إذا وجدت أن شخصًا آخر قد استخدم أو سرق اسم تسجيل الدخول وكلمة المرور الخاصين بحسابك، أو أي استخدام آخر غير مصرح به، فيجب عليك إخطار النظام الأساسي على الفور بطريقة فعالة ومطالبة النظام الأساسي بتعليق الخدمات ذات الصلة؛ و (ب) التأكد من مغادرة الموقع بالخطوات الصحيحة في نهاية فترة تسجيل الدخول المستمرة. لا يمكن لهذه المنصة ولن تكون مسؤولة عن أي خسارة أو ضرر أو عواقب سلبية أخرى تحدث بسبب فشلك في الالتزام بهذا البند. أنت تدرك أن هذا النظام الأساسي يتطلب حدًا زمنيًا معقولًا لاتخاذ إجراء بشأن طلبك. قبل ذلك، لن تكون المنصة مسؤولة عن التعليمات المنفذة و/أو الخسائر التي تتكبدها بسببها.</p><p>4.3 ما لم تكن هناك لوائح قانونية أو أحكام قضائية، وبموافقة هذه المنصة، لا يجوز نقل الحساب أو إهدائه أو توريثه بأي شكل من الأشكال (باستثناء حقوق الملكية ذات الصلة).</p><p>4.4 أنت توافق على أنه، بناءً على احتياجات التشغيل وأمن المعاملات، قد تتوقف هذه المنصة مؤقتًا عن تقديم أو تقييد بعض وظائف هذه الخدمة، أو تقديم وظائف جديدة. عند تقليل أي وظيفة أو زيادتها أو تغييرها، طالما أنك لا تزال تستخدم هذه الخدمة، فهذا يعني أنك لا تزال توافق على هذه الاتفاقية أو الاتفاقية التي تم تغييرها.</p><p>4.5 يحق لهذه المنصة معرفة الخلفية الحقيقية للمعاملة والغرض من استخدامك لمنتجات أو خدمات المنصة. يجب عليك تقديم المعلومات الحقيقية والشاملة والدقيقة التي تتطلبها المنصة بصدق؛ إذا كان لدى النظام الأساسي أسباب معقولة للاشتباه في أنك تقدم معلومات معاملة كاذبة، فإن لهذا النظام الأساسي الحق في تقييد جزء أو كل وظائف المنتجات أو الخدمات التي تستخدمها بشكل مؤقت أو دائم.</p><p>4.6 أنت توافق على أنه من أجل سلامة حسابك وأصوله الرقمية، وفقًا لأحكام هذه الاتفاقية والقوانين واللوائح والوثائق القانونية، فإن متطلبات الحكومة وفقًا للصلاحيات الإدارية، وحكم المنصة الخاصة التي قد تؤثر على ذلك حسابك في حالة وجود خطر، يحق للمنصة تجميد كل أو جزء من الحسابات تحت اسمك، أي إغلاق بعض أو كل هذه الحسابات مؤقتًا. عملية التجميد العكسية هي إلغاء التجميد، أي أن المنصة تنهي تجميد الحساب المجمد. عند حدوث التجميد، إذا قمت بتقديم طلب لإلغاء التجميد، يحق للمنصة أن تقرر ما إذا كانت ستسمح بإلغاء التجميد الكامل أو الجزئي بناءً على أسباب التجميد المذكورة أعلاه وفقًا لهذا البند. يجب أن تفهم تمامًا أن طلبك لإلغاء التجميد غير مسموح به بالضرورة، ويجب عليك عند إلغاء التجميد أن تتعاون مع المتطلبات ذات الصلة لهذا النظام الأساسي للتحقق من هويتك، وتقديم ما في ذلك على سبيل المثال لا الحصر معلومات الهوية وبطاقة الهوية وجواز السفر، وثائق هوية صالحة أخرى وغيرها من المعلومات أو المستندات التي تتطلبها هذه المنصة.</p><p><strong>5 قواعد استخدام الحساب</strong></p><p>من أجل حماية حقوقك القانونية بشكل فعال عند استخدام هذه الخدمة، فإنك تفهم القواعد التالية وتوافق على قبولها:</p><p>5.1 بمجرد استخدامك لهذه الخدمة، فإنك تسمح لهذه المنصة بالعمل كوكيل لتسوية الأصول الرقمية بينك وبين المستخدمين الذين يستوفون الشروط المحددة.</p><p>5.2 تقبل هذه المنصة التعليمات منك بالطريقتين التاليتين: أولاً، تقوم بتسجيل الدخول إلى حسابك باستخدام اسم حسابك وكلمة المرور على هذا الموقع وتعديل أو تأكيد حالة المعاملة أو التعليمات وفقًا للعملية المحددة مسبقًا لهذه الخدمة؛ ثانيًا، تقوم بالرد على المعلومات المرسلة إلى النظام عبر البريد الإلكتروني أو الهاتف المحمول أو أي أداة اتصال أخرى مخصصة لك كاسم الحساب أو الحساب المرتبط بالحساب عند التسجيل. وبغض النظر عما إذا قمت بإرسال تعليمات إلى المنصة من خلال أي من الطريقتين المذكورتين أعلاه، فلا يمكن سحبها أو إبطالها، وتصبح التعليمات الوحيدة للمنصة لدفع أو استلام الأموال أو إجراء عمليات حسابية أخرى نيابة عنك. ويعتبر بمثابة التعليمات الخاصة بك. يجب أن تكون مسؤولاً عن أي نتائج ناجمة عن تنفيذ النظام الأساسي للتعليمات المذكورة أعلاه. باستثناء ما هو منصوص عليه خلافًا لذلك في هذه الاتفاقية، عندما يكون لديك نزاع بشأن معاملة مع طرف ثالث، فإنك تأذن لهذه المنصة بإصدار حكمها الخاص وتقرر دفع كل أو جزء من المبلغ المتنازع عليه إلى أحد طرفي المعاملة أو كليهما.</p><p>5.3 ستعلمك هذه المنصة بتقدم المعاملة وتطالبك باتخاذ الخطوة التالية عن طريق البريد الإلكتروني (أو رسالة نصية قصيرة أو مكالمة هاتفية مرسلة إلى الهاتف المحمول، وما إلى ذلك)، ولكن هذه المنصة لا تضمن أنه يمكنك استلام البريد الإلكتروني أو استلامه في الوقت المناسب (أو الرسائل النصية أو المكالمات الهاتفية المرسلة إلى الهاتف المحمول وغيرها)، ولا تتحمل أي عواقب، لذلك يجب عليك تسجيل الدخول إلى هذا الموقع في الوقت المناسب لعرض وإجراء عمليات المعاملة أثناء عملية المعاملة. هذه المنصة ليست مسؤولة عن أي نزاعات أو خسائر ناجمة عن فشلك في عرض وتعديل أو تأكيد حالة المعاملة في الوقت المناسب أو الفشل في تقديم الطلب ذي الصلة.</p><p>5.4 يتم نقل الأصول الرقمية بموجب هذه الاتفاقية من خلال الشبكة المقابلة، وأنت تفهم وتوافق على وقت معقول أثناء نقل الأصول الرقمية الخاصة بك.</p><p>5.5 مخاطر المعاملات</p><p>أ. عند استخدام هذه الخدمة، إذا ارتكبت أنت أو تعليمات المعاملة الخاصة بك أخطاء (بما في ذلك على سبيل المثال لا الحصر السعر والكمية وعوامل أخرى) تسببت في خسارة معاملتك، فستكون مسؤولاً عن الخسارة.</p><p>ب. أي خسارة ناجمة عن خطأك سوف تتحملها أنت. يتضمن الخطأ على سبيل المثال لا الحصر: الفشل في اتباع مطالبات المعاملات، والفشل في تنفيذ عمليات المعاملات في الوقت المناسب، ونسيان كلمات المرور أو تسريبها، واختراق كلمات المرور من قبل الآخرين، واستخدام جهاز الكمبيوتر الخاص بك من قبل الآخرين Invade.</p><p>ج. عند استخدام هذه الخدمة، إذا حصلت على مكاسب غير مبررة بسبب ثغرة محتملة غير مكتشفة في نظام أو قواعد التداول بالموقع، يحق لهذا الموقع الاتصال بك لاستعادتها، ويجب عليك التعاون بشكل فعال، وإلا فإن هذا الموقع يتخذ تدابير حق الرجوع بما في ذلك، ولكن على سبيل المثال لا الحصر، سيتم فرض قيود على معاملات الحساب، وتجميد أموال الحساب، ورفع الدعاوى القضائية. تكاليف اللجوء التي نتكبدها بسبب فشلك في التعاون بشكل فعال سوف تتحملها أنت أيضًا.</p><p>5.6. أنت تدرك وتوافق على أن هذه المنصة ليست مسؤولة عن أي أضرار ناجمة عن أي من الظروف التالية، بما في ذلك على سبيل المثال لا الحصر الخسائر في الأرباح والسلع والبيانات وما إلى ذلك:</p><p>أ. يحق لهذه المنصة تعليق أو مقاطعة أو إنهاء تقديم هذه الخدمة أو أي جزء من الحساب تحت اسمك بناءً على حكم أحادي الجانب، بما في ذلك على سبيل المثال لا الحصر، اعتقاد المنصة أنك قد انتهكت الأحكام الصريحة وروح هذا الاتفاقية، وإزالة البيانات الخاصة بك.</p><p>ب. يحق لهذه المنصة تعليق أو إنهاء استخدام الحسابات تحت اسمك دون سابق إنذار (بما في ذلك على سبيل المثال لا الحصر، استخدام الحسابات تحت اسمك) عندما تكتشف معاملات غير طبيعية أو شكوك أو انتهاكات للقوانين أو أحكام هذه الاتفاقية. تتخذ عمليات الدفع والمعاملات العابرة إجراءات تقييدية مثل إلغاء المعاملات وتعديلات الحساب)، وترفض استخدام بعض أو كل وظائف هذه الخدمة.</p><p><strong>6. رسوم الخدمة</strong></p><p>6.1 عند استخدامك لهذه الخدمة، يحق لهذه المنصة فرض رسوم الخدمة عليك وفقًا لـ "قواعد رسوم خدمة الحساب". يحق لهذه المنصة صياغة وتعديل رسوم الخدمة. تخضع رسوم الخدمة المحددة للإعلان عن طريقة الشحن المدرجة في هذا الموقع عند استخدام الخدمة أو غيرها من الاتفاقيات المكتوبة التي تم التوصل إليها بينك وبين المنصة.</p><p>6.2 ما لم ينص على خلاف ذلك أو يتم الاتفاق عليه، فإنك توافق على أن هذه المنصة لها الحق في خصم رسوم الخدمة المذكورة أعلاه مباشرة من الأموال التي تعهدت بها هذه المنصة لإدارتها أو تحصيلها أو دفعها.</p><p><strong>7. حماية الخصوصية</strong></p><p><strong>بمجرد موافقتك على هذه الاتفاقية أو استخدام هذه الخدمة، فإنك توافق على أن هذه المنصة ستستخدم معلوماتك الشخصية وتكشف عنها وفقًا للشروط التالية.</strong></p><p><strong>7.1 اسم تسجيل الدخول للحساب وكلمة المرور</strong></p><p><strong>عندما تقوم بالتسجيل للحصول على حساب وخدمة، سنطلب منك تعيين اسم تسجيل الدخول وكلمة المرور لحسابك لتحديد هويتك، وإعداد التحقق عبر الرسائل النصية القصيرة للهاتف المحمول ومصادقة الاسم الحقيقي لتأكيد هويتك عندما تفقد كلمة المرور الخاصة بك. يمكنك فقط استخدام الحساب بكلمة المرور التي قمت بتعيينها. إذا قمت بتسريب كلمة المرور الخاصة بك، فقد تفقد معلومات التعريف الشخصية الخاصة بك وقد تتسبب في عواقب قانونية غير مناسبة لك. عندما يكون الحساب وكلمة المرور في خطر محتمل أو فعلي لأي سبب من الأسباب، يجب عليك الاتصال بالمنصة على الفور. قبل أن تتخذ المنصة أي إجراء، فإن المنصة ليست مسؤولة عن ذلك.</strong></p><p><strong>7.2 معلومات التسجيل</strong></p><p><strong>يجب عليك تقديم المعلومات ذات الصلة مثل رقم هاتفك وعنوان بريدك الإلكتروني عند التسجيل. من أجل تزويدك بخدمات وفرص جديدة بطريقة مستهدفة، فإنك تفهم وتوافق على أن هذه المنصة سترسل لك الإخطارات ذات الصلة والمعلومات الإلكترونية التجارية الأخرى من خلال معلومات الاتصال الخاصة بك (بما في ذلك، على سبيل المثال لا الحصر، الهواتف المحمولة ورسائل البريد الإلكتروني وما إلى ذلك) .</strong></p><p><strong>7.3 سلوك المعاملات</strong></p><p><strong>من أجل ضمان سلامة استخدامك للخدمة والتحسين المستمر لجودة الخدمة، ستقوم هذه المنصة بتسجيل وحفظ المعلومات ذات الصلة حول تسجيل الدخول الخاص بك واستخدامك لهذه الخدمة، ولكن هذه المنصة تتعهد بعدم تقديم مثل هذه المعلومات إلى أي طرف ثالث (ما لم يتفق الطرفان على خلاف ذلك أو ما لم تنص القوانين واللوائح على خلاف ذلك).</strong></p><p><strong>7.4 أنت توافق على أنه من أجل تقديم الخدمات لك بشكل أكثر أمانًا وفعالية، وفقًا للقوانين واللوائح، أو تحتاج المنصة إلى تحديد هويتك، أو تعتقد المنصة أن حسابك في خطر، يحق للمنصة أن تطلب عليك تقديم معلومات الهوية (بما في ذلك على سبيل المثال لا الحصر، بطاقات الهوية ودفاتر تسجيل الأسرة وجوازات السفر وغيرها من المستندات أو المستندات الأخرى). باستثناء ما هو منصوص عليه خلاف ذلك في هذه الاتفاقية،</strong></p><p><strong>أ. الحصول على إذن صريح منك مسبقًا؛</strong></p><p><strong>ب. الإفصاح وفقا لمتطلبات هذه الاتفاقية؛</strong></p><p><strong>ج. وفقا للقوانين واللوائح؛</strong></p><p><strong>د. وفقاً لمتطلبات الجهات الحكومية؛</strong></p><p><strong>ه. لحماية الحقوق والمصالح المشروعة لهذه المنصة.</strong></p><p><strong>7.5 الروابط الخارجية</strong></p><p><strong>يحتوي هذا الموقع على روابط لمواقع أخرى، ولكن هذه المنصة ليست مسؤولة عن تدابير حماية الخصوصية للمواقع الأخرى. قد تضيف هذه المنصة شركاء أعمال أو مواقع ويب تجارية مشتركة عند الضرورة.</strong></p><p><strong>7.6 الأمن</strong></p><p><strong>توفر هذه المنصة فقط الإجراءات الأمنية المقابلة وفقًا للتكنولوجيا الحالية لمنع فقدان المعلومات التي تحتفظ بها هذه المنصة وإساءة استخدامها وتغييرها. تتضمن إجراءات الأمان هذه نسخ البيانات احتياطيًا إلى خوادم أخرى وتشفير كلمات مرور المستخدم. وعلى الرغم من هذه الإجراءات الأمنية، فإن هذه المنصة لا تضمن الأمان المطلق لهذه المعلومات.</strong></p><p><strong>8. انقطاع النظام أو فشله</strong></p><p>عندما يفشل النظام في العمل بشكل طبيعي بسبب الظروف التالية، بحيث لا تتمكن من استخدام الخدمات المختلفة، فإن هذه المنصة لن تكون مسؤولة عن الأضرار، بما في ذلك على سبيل المثال لا الحصر:</p><p>8.1 خلال فترة إيقاف تشغيل النظام وصيانته المعلنة على موقع المنصة. 8.2 فشل معدات الاتصالات في نقل البيانات.</p><p>8.3 بسبب عوامل القوة القاهرة مثل الأعاصير والزلازل والتسونامي والفيضانات وانقطاع التيار الكهربائي والحروب والهجمات الإرهابية وعوامل القوة القاهرة الأخرى، لا يمكن تنفيذ نظام هذه المنصة بسبب عوائق النظام.</p><p>8.4 انقطاع الخدمة أو تأخيرها بسبب هجمات القراصنة، أو اختراق فيروسات الكمبيوتر أو الهجوم عليها، أو التعديلات الفنية أو الأعطال في أقسام الاتصالات، أو تحديث مواقع الويب، أو الإغلاق المؤقت بسبب السيطرة الحكومية، وغيرها من الأسباب التي تؤثر على التشغيل العادي للشبكة.</p><p>8.5 يعمل المستخدم بشكل غير صحيح أو يستخدم خدمات المنصة بطريقة غير مصرح بها أو معتمدة من قبل المنصة.</p><p>8.6 وجود خلل في برامج وأجهزة الكمبيوتر الخاصة بالمستخدم، وخطوط الاتصال، وخطوط إمداد الطاقة.</p><p><strong>9. نطاق المسؤولية وحدود المسؤولية</strong></p><p>هذه المنصة مسؤولة فقط عن نطاق المسؤوليات المحددة في هذه الاتفاقية.</p><p>9.1 يتم توفير معلومات المستخدم على هذه المنصة من قبل المستخدم نفسه، ولا يمكن للمنصة ضمان دقة المعلومات وصحتها واكتمالها.</p><p>9.2 قد توفر المنصة خدمات المنصة لك وللطرف المقابل (المعاملة) في نفس الوقت. أنت توافق على الإعفاء صراحةً من أي تضارب فعلي أو محتمل في المصالح من مثل هذه الإجراءات التي قد تكون موجودة على المنصة، ولن تتمكن من الادعاء بأن المنصة هي التي توفر المنصة. هناك عيوب قانونية في الخدمة.</p><p>9.3 إذا قمت بتنزيل أو الحصول على أي بيانات من خلال استخدام هذه الخدمة، فيجب عليك اعتبار ذلك بنفسك وعلى مسؤوليتك الخاصة. أي ضرر يلحق بنظام الكمبيوتر الخاص بك أو فقدان البيانات بسبب تنزيل البيانات يجب أن يتحمل المسؤولية الكاملة عنك.</p><p>9.4 النصائح والمعلومات التي تحصل عليها من هذه المنصة وموظفيها أو من خلال هذه الخدمة، سواء كانت مكتوبة أو شفهية، لا تشكل ضمانة المنصة لهذه الخدمة.</p><p><strong>10. الاتفاقية الكاملة</strong></p><p>تتكون هذه الاتفاقية من شروط هذه الاتفاقية و"قواعد رسوم الخدمة" والقواعد الأخرى المنشورة على هذا الموقع. يمكن اقتباس المصطلحات ذات الصلة والإشارة إلى بعضها البعض. إذا كان هناك فهم مختلف، فإن شروط هذه الاتفاقية هي التي تسود. إذا فهمت هذه الاتفاقية ووافقت عليها، فإنك تفهم وتوافق على جميع مكونات هذه الاتفاقية. بمجرد استخدامك لهذه الخدمة، ستكون أنت وهذه المنصة ملزمين بجميع مكونات هذه الاتفاقية. إذا اعتبرت سلطة قضائية ذات اختصاص قضائي جزءًا من محتوى هذه الاتفاقية غير قانوني، فلن يؤثر ذلك على فعالية المحتوى الآخر.</p><p><strong>11. حماية العلامات التجارية وحقوق الملكية الفكرية</strong></p><p>11.1 جميع محتويات هذا الموقع، بما في ذلك على سبيل المثال لا الحصر، الأعمال والصور والملفات والمعلومات والمواد وبنية الموقع وترتيب شاشة الموقع وتصميم الويب، مملوكة للمنصة وفقًا للقانون، بما في ذلك على سبيل المثال لا الحصر حقوق العلامات التجارية وبراءات الاختراع الحقوق وحقوق النشر والأسرار التجارية وما إلى ذلك.</p><p>11.2 بدون موافقة كتابية من هذه المنصة، لا يجوز لأي شخص استخدام أو تعديل أو نسخ أو نشر أو تغيير أو توزيع أو إصدار أو نشر إجراءات أو محتوى هذا الموقع بشكل علني دون إذن.</p><p>11.3 احترام حقوق الملكية الفكرية هو التزامك. إذا كان هناك أي انتهاك، سوف تكون مسؤولاً عن الأضرار.</p><p><strong>12. تطبيق القانون والاختصاص القضائي</strong></p><p>إن صحة هذه الاتفاقية وتفسيرها وتعديلها وتنفيذها وحل المنازعات تنطبق جميعها على قوانين المكان الذي توجد فيه المنصة. إذا لم يكن هناك نص قانوني ذي صلة، فارجع إلى الممارسات التجارية الدولية العامة و/أو الممارسات الصناعية. يتم التعامل مع النزاعات الناشئة عن هذه الاتفاقية وفقًا لقانون المكان الذي توجد فيه المنصة، وتكون السلطة القضائية في المكان الذي توجد فيه المنصة هي السلطة القضائية الابتدائية.</p>`,

  privacyPolicyTitle: 'سياسة الخصوصية',
  privacyPolicy: `<p><strong>ينطبق بيان الخصوصية هذا على جميع الخدمات ذات الصلة بـ FTZINC. تحترم FTZINC وتحمي الخصوصية الشخصية لجميع المستخدمين الذين يستخدمون خدمات منصة FTZINC. من أجل تزويدك بخدمات أكثر دقة وتخصيصًا، ستستخدم معلوماتك الشخصية وتكشف عنها وفقًا لأحكام سياسة الخصوصية هذه، لكن FTZINC ستتعامل مع هذه المعلومات بدرجة عالية من العناية والحكمة. باستثناء ما هو منصوص عليه خلافًا لذلك في سياسة الخصوصية هذه، لن تقوم FTZINC بالكشف عن هذه المعلومات أو تقديمها إلى أطراف ثالثة دون الحصول على إذن مسبق منك. ستقوم FTZINC بتحديث سياسة الخصوصية هذه من وقت لآخر. عندما توافق على اتفاقية خدمة FTZINC، فإنك تعتبر موافقًا على المحتوى الكامل لسياسة الخصوصية هذه. تعد سياسة الخصوصية هذه جزءًا لا يتجزأ من اتفاقية الخدمة.</strong></p><p><strong>1. نطاق الاستخدام</strong></p><p><strong>عندما تقوم بالتسجيل أو تنشيط حساب يمكنه تسجيل الدخول إلى منصتنا، فإن معلومات التسجيل الشخصية الخاصة بك المقدمة على منصات أخرى توفرها الشركات التابعة لنا (باستثناء معلومات تسجيل الأعمال ذات الصلة مثل أسماء الأعمال التي يجب الكشف عنها وفقًا للقوانين واللوائح ومعلومات عن مشغلي الأشخاص الطبيعيين؛ عند استخدام صفحات الويب FTZINC أو FTZINC، تقوم FTZINC أيضًا بتسجيل المعلومات الموجودة على متصفحك وجهاز الكمبيوتر الخاص بك، بما في ذلك على سبيل المثال لا الحصر عنوان IP الخاص بك ونوع المتصفح واللغة المستخدمة وتاريخ ووقت الوصول وبيانات البرنامج. مثل معلومات ميزات الأجهزة وسجلات صفحات الويب التي تحتاجها، والبيانات الشخصية للمستخدمين التي تم الحصول عليها من شركاء الأعمال من خلال FTZINC.</strong></p><p><strong>2. استخدام المعلومات</strong></p><p><strong>لن نقدم معلوماتك الشخصية أو نبيعها أو نؤجرها أو نشاركها أو نتاجر بها مع أي طرف ثالث لا علاقة له به، إلا إذا حصلت على إذن منك مقدمًا، أو قدم الطرف الثالث ونحن (بما في ذلك الشركات التابعة لنا) الخدمات لك بشكل فردي أو مشترك، و وبعد انتهاء الخدمة، سيتم منعه من الوصول إلى جميع هذه المواد التي كانت عليها</strong></p><p><strong>قادر على الوصول من قبل. كما أننا لا نسمح لأي طرف ثالث بجمع معلوماتك الشخصية أو تعديلها أو بيعها أو نشرها بأي وسيلة. إذا شارك أي مستخدم لمنصتنا في الأنشطة المذكورة أعلاه، فبمجرد اكتشافها، يحق لنا إنهاء اتفاقية الخدمة مع هذا المستخدم على الفور.</strong></p><p><strong>3. الكشف عن المعلومات</strong></p><p><strong>في ظل الظروف التالية، سنكشف عن معلوماتك الشخصية كليًا أو جزئيًا وفقًا لرغباتك الشخصية أو اللوائح القانونية: بموافقتك المسبقة، الكشف عنها لطرف ثالث؛ إذا كنت مشتكيًا مؤهلاً بشأن الملكية الفكرية وقمت بتقديم شكوى، فاكشف للمدعى عليه بناءً على طلب المدعى عليه، حتى يتمكن الطرفان من التعامل مع النزاعات المحتملة على الحقوق؛ الإفصاح وفقًا لأحكام القانون ذات الصلة، أو متطلبات المؤسسات الإدارية أو القضائية، لطرف ثالث أو مؤسسات إدارية أو قضائية؛ إذا انتهكت القوانين أو اللوائح ذات الصلة أو يجب الكشف عن اتفاقيات الخدمة أو القواعد ذات الصلة لأطراف ثالثة؛ من أجل توفير المنتجات والخدمات التي تطلبها، يجب عليك مشاركة معلوماتك الشخصية مع أطراف ثالثة؛ في معاملة تم إنشاؤها على منصتنا إذا استوفى أي طرف في المعاملة أو استوفى جزئيًا التزام المعاملة وطلب الكشف عن المعلومات، فيحق لنا أن نقرر تزويد المستخدم بالمعلومات الضرورية مثل معلومات الاتصال الخاصة بالطرف المقابل لتسهيل الأمر إتمام الصفقة أو تسوية النزاع. نقوم بالإفصاحات التي نعتبرها مناسبة وفقًا للقوانين أو اللوائح أو سياسات موقع الويب.</strong></p><p><strong>4. تخزين المعلومات وتبادلها</strong></p><p><strong>سيتم تخزين المعلومات والبيانات التي نجمعها عنك على خوادمنا و(أو) الشركات التابعة لها. قد يتم نقل هذه المعلومات والبيانات إلى بلدك أو منطقتك أو إلى الخارج حيث نجمع المعلومات والبيانات ويمكن الوصول إليها وتخزينها وعرضها في الخارج.</strong></p><p><strong>5. استخدام ملفات تعريف الارتباط</strong></p><p><strong>إذا لم ترفض قبول ملفات تعريف الارتباط، فسنقوم بتعيين ملفات تعريف الارتباط أو الوصول إليها على جهاز الكمبيوتر الخاص بك حتى تتمكن من تسجيل الدخول أو استخدام خدمات أو وظائف النظام الأساسي لدينا التي تعتمد على ملفات تعريف الارتباط. نحن نستخدم ملفات تعريف الارتباط لتزويدك بخدمات أكثر تفصيلاً وتخصيصًا، بما في ذلك الخدمات الترويجية. لديك الحق في اختيار قبول أو رفض قبول ملفات تعريف الارتباط. يمكنك رفض قبول ملفات تعريف الارتباط عن طريق تعديل إعدادات المتصفح الخاص بك. ولكن إذا اخترت رفض قبول ملفات تعريف الارتباط، فقد لا تتمكن من تسجيل الدخول أو استخدام خدمات أو وظائف النظام الأساسي لدينا التي تعتمد على ملفات تعريف الارتباط. سيتم تطبيق هذه السياسة على المعلومات ذات الصلة التي يتم الحصول عليها من خلال ملفات تعريف الارتباط التي تحددها FTZINC؛</strong></p><p><strong>6. أمن المعلومات</strong></p><p><strong>يحتوي حسابك على وظيفة الحماية الأمنية، يرجى الاحتفاظ بمعلومات حسابك وكلمة المرور بشكل صحيح. سنستخدم إجراءات أمنية مثل النسخ الاحتياطي على خوادم أخرى وتشفير كلمات مرور المستخدم لضمان عدم فقدان معلوماتك أو إساءة استخدامها أو تغييرها. على الرغم من التدابير الأمنية المذكورة أعلاه، يرجى ملاحظة أنه لا يوجد "إجراء أمني مثالي" على شبكة المعلومات. عند استخدام خدمات النظام الأساسي لدينا للمعاملات عبر الإنترنت، يتعين عليك حتماً الكشف عن معلوماتك الشخصية، مثل معلومات الاتصال أو العنوان البريدي، إلى الطرف المقابل أو الطرف المقابل المحتمل. يرجى حماية معلوماتك الشخصية بشكل صحيح وتقديمها للآخرين فقط عند الضرورة. إذا وجدت أن معلوماتك الشخصية قد تم تسريبها، وخاصة حسابك وكلمة المرور، فيرجى الاتصال بخدمة العملاء لدينا على الفور حتى نتمكن من اتخاذ الإجراءات المناسبة. احتياطات خاصة للقاصرين إذا لم تكن شخصًا طبيعيًا يتمتع بالأهلية الكاملة للحقوق المدنية والأهلية الكاملة للسلوك المدني، فلا يحق لك استخدام خدمات المنصة الخاصة بنا، لذا نأمل ألا تزودنا بأي معلومات شخصية.</strong></p><p><strong>بعد إنهاء خدمة حسابك أو تجميد (إلغاء) سلطة الحساب في FTZINC بشكل دائم، لا تتحمل FTZINC أي التزام بالاحتفاظ بأي معلومات في حسابك أو الكشف عنها لك، كما أنها ليست ملزمة بإعادة توجيه أي معلومات لم تقرأها إليك أو طرف ثالث أو الرسالة المرسلة.</strong></p><p><strong>أنت توافق على أنه بعد إنهاء علاقتك التعاقدية مع FTZINC، لا تزال FTZINC تتمتع بالحقوق التالية: الاستمرار في تخزين معلومات المستخدم الخاصة بك وجميع معلومات المعاملات أثناء استخدامك لخدمة FTZINC. إذا قمت بانتهاك القانون أو انتهاك هذه الاتفاقية و/أو القواعد أثناء استخدامك لخدمة FTZINC، فلا يزال بإمكان FTZINC المطالبة بحقوقك وفقًا لهذه الاتفاقية.</strong></p><p><strong>بعد قيام FTZINC بتعليق أو إنهاء تقديم خدمات FTZINC لك، سيتم التعامل مع معاملاتك قبل تعليق الخدمة أو إنهائها وفقًا للمبادئ التالية، ويجب عليك التعامل معها بمفردك وتتحمل بشكل كامل أي نزاعات أو خسائر أو أي تكاليف إضافية الناشئة عن المعالجة التالية. ويجب أيضًا التأكد من أن FTZINC خالية من أي خسارة أو تكبد أي تكاليف نتيجة لذلك: إذا كانت العملة الافتراضية مثل البيتكوين وغيرها من العملات الافتراضية التي قمت بتحميلها على FTZINC قبل تعليق الخدمة أو إنهائها لم يتم تداولها بعد ، يحق لـ FTZINC أن تكون قد تداولت بالفعل مع أعضاء آخرين إذا توصلوا إلى عقد بيع، ولكن لم يتم تنفيذ العقد فعليًا، يحق لـ FTZINC حذف عقد البيع والمعلومات المتعلقة بالعملة الافتراضية مثل Bitcoin وغيرها العملات الافتراضية؛ لقد توصلت إلى عقد بيع مع أعضاء آخرين قبل تعليق الخدمة أو إنهائها، وإذا تم الوفاء بها جزئيًا، فلا يجوز لـ FTZINC حذف المعاملة، ولكن يحق لـ FTZINC إخطار الطرف المقابل بالظروف ذات الصلة عند تعليق الخدمة أو إنهائها .</strong></p><p><strong>7. سياسة الخصوصيةستقوم FTZINC بالإعلان عن سياسة الخصوصية الخاصة بها ومراجعتها على موقع FTZINC من وقت لآخر. تشكل سياسة الخصوصية جزءا فعالا من هذه الاتفاقية.</strong></p>`,

  legalStatementTitle: 'بيان قانوني',
  legalStatement: `<p><strong>المادة 1:</strong></p><p>يهدف هذا الموقع إلى توفير خدمات إدارة الأصول ومعاملات الأصول الرقمية الاحترافية والآمنة والجديرة بالثقة لعشاق الأصول الرقمية والمستثمرين من جميع أنحاء العالم إلى أقصى حد ممكن دون انتهاك القوانين واللوائح ذات الصلة في الولايات المتحدة. ومع ذلك، إذا كانت الدولة أو المنطقة التي تقيم فيها هي ولاية قضائية تُحظر فيها معاملات الأصول الرقمية صراحةً أو ولاية قضائية مدرجة في قائمة الدول الخاضعة للعقوبات، فيجب عليك الامتناع عن استخدام الخدمات التي يقدمها هذا الموقع.</p><p><strong>المادة 2:</strong></p><p>تلتزم هذه المنصة بإنشاء بيئة تداول أصول رقمية متوافقة وآمنة وموثوقة لمستخدميها. يُحظر على مستخدميه استخدام هذا الموقع للمشاركة في غسيل الأموال والتهريب والرشوة التجارية والتلاعب الخبيث بالسوق وغيرها من أنشطة التجارة غير القانونية أو الأنشطة غير القانونية. وفي ضوء ذلك، نقوم، إلى أقصى حد ممكن، بصياغة برنامج صارم لمكافحة غسيل الأموال ومكافحة الإرهاب واتخاذ تدابير فعالة للتحكم في المخاطر الأمنية لتعظيم الحقوق والمصالح المشروعة للمستخدمين، والحفاظ على السمعة الطيبة للمنصة</p><p><strong>المادة 3:</strong></p><p>عندما تطلب سلطة مختصة، بناءً على مذكرة التحقيق ذات الصلة، من المنصة التعاون معها في التحقيق مع أي مستخدم محدد له، أو اعتماد إجراءات ضد حساب المستخدم مثل إغلاق أو تجميد هذا الحساب أو نقل الأصول من هذا الحساب، فإن هذا يجب على موقع الويب، بعد التحقق من صحة وصحة هذا الأمر، تزويد السلطة بالبيانات ذات الصلة بالمستخدم أو تنفيذ العمليات المقابلة، وذلك للمساعدة في التحقيق وفقًا لمتطلبات هذه السلطة المختصة. لا تتحمل المنصة أي مسؤولية عن أي خسارة مباشرة أو غير مباشرة قد يتكبدها المستخدم بسبب أي كشف عن خصوصية المستخدم، أو عدم قدرة المستخدم على تشغيل حسابه بسبب هذا التحقيق.</p><p><strong>المادة 4:</strong></p><p>يجب على المستخدمين الذين يستخدمون الخدمات التي يقدمها هذا الموقع، قبل الانخراط في المعاملات، أن يدركوا أن: الأصول الرقمية غير مدعومة من قبل أي حكومة أو بنك مركزي، وأن أسعار الأصول الرقمية تخضع لتقلبات كبيرة، وأن الاحتفاظ بها أو استخدام الأصول الرقمية يخضع لمخاطر كبيرة. وفي ضوء ذلك، قبل اتخاذ قرار التداول، يجب عليك تقييم وضعك المالي بطريقة عقلانية وحكيمة، لتحديد ما إذا كانت الصفقة المقترحة مناسبة لك.</p><p><strong>المادة 5:</strong></p><p>إذا انتهك مستخدم هذا الموقع أي شرط من هذا البيان وبالتالي انتهك أيًا من القوانين ذات الصلة في جمهورية سيشيل، فإن هذا الموقع، باعتباره مقدم الخدمة بموجب هذه الاتفاقية، ملزم بتحسين قواعد وخدمات المنصة، ومع ذلك، بشرط ألا يكون لهذا الموقع أي دافع لانتهاك أي من هذه القوانين ذات الصلة بالولايات المتحدة، كما أنه ليس لديه أي حقيقة لانتهاك هذه القوانين؛ ولذلك، لن يكون هذا الموقع مسؤولاً بشكل مشترك عن أي من سلوكيات هذا المستخدم.</p><p><strong>المادة 6:</strong></p><p>يعتبر المستخدم الذي يقوم بتسجيل الدخول إلى هذا الموقع بأي شكل من الأشكال، أو يستخدم خدمات هذا الموقع بشكل مباشر أو غير مباشر، موافقًا على محتوى هذا البيان ويوافق طوعًا على الالتزام بهذا البيان.</p><p><strong>المادة 7:</strong></p><p>بالنسبة للمسائل التي لم يغطيها هذا البيان، يرجى الرجوع إلى القوانين واللوائح ذات الصلة في الولايات المتحدة. عندما يتعارض هذا البيان مع أي من القوانين واللوائح ذات الصلة في الولايات المتحدة، فإن الأخيرة هي التي تسود.</p>`,

  launderingPolicyTitle: 'سياسة مكافحة غسيل الأموال',
  launderingPolicy: `<p><strong>المادة 1:</strong></p><p><strong>الغرض وأساس الصياغة في ضوء حقيقة أن أنشطة غسيل الأموال ستضر بشكل خطير بتطوير معاملات الأصول الرقمية، وتشجع الفساد وتولده، وتقوض الجو الاجتماعي، وتضر بالحقوق والمصالح المشروعة للمستخدمين، وتقوض أساس الدولة. التشغيل المستقر لمنصات تداول الأصول الرقمية. من أجل منع أنشطة غسيل الأموال وتمويل الإرهاب، تفي FTZINC بالأحكام ذات الصلة بقوانين مكافحة غسيل الأموال وتمويل الإرهاب وفقًا لـ "قواعد FTZINC لمكافحة غسيل الأموال" و"اتفاقية العميل" و"المعاملات ذات القيمة الكبيرة". ". تمت صياغة هذه الإرشادات وفقًا للوائح الشركة مثل إجراءات الإدارة.</strong></p><p><strong>المادة 2:</strong></p><p><strong>نطاق التطبيق تنطبق هذه الإرشادات على جميع المستخدمين الذين يشاركون في المعاملات على منصة التداول FTZINC. يجب على المستخدم الالتزام بالقوانين واللوائح المتعلقة بمكافحة غسل الأموال وتمويل الإرهاب في الدولة أو المنطقة التي يتواجد فيها المستخدم، وتنفيذ أحكام هذا الدليل ضمن النطاق الذي تنص عليه قوانين المنطقة التي يعيش فيها المستخدم. إذا كانت الدولة أو المنطقة التي يتواجد فيها المستخدم لديها متطلبات أكثر صرامة، فاتبع لوائحها.</strong></p><p><strong>المادة 3:</strong></p><p><strong>تشير مكافحة غسيل الأموال ومكافحة تمويل الإرهاب إلى غرض منع المجرمين من إجراء المعاملات عبر منصة FTZINC لإخفاء وإخفاء جرائم المخدرات والجرائم المنظمة ذات الطبيعة الإجرامية والجرائم الإرهابية وجرائم التهريب وجرائم الفساد والرشوة، جرائم الاحتيال المالي، والتخريب، وجرائم أمر الإدارة المالية وغيرها من الدخل غير القانوني ومصدر وطبيعة أنشطة غسيل الأموال، وفقًا للقوانين ذات الصلة ولوائح FTZINC لمكافحة غسيل الأموال لاتخاذ التدابير ذات الصلة.</strong></p><p><strong>المادة 4:</strong></p><p><strong>اللوائح ذات الصلة بمكافحة غسيل الأموال في FTZINC تتضمن القواعد ذات الصلة بمكافحة غسيل الأموال في FTZINC (بما في ذلك تمويل مكافحة الإرهاب، كما هو موضح أدناه) "قواعد FTZINC لمكافحة غسيل الأموال"، وجزء مكافحة غسيل الأموال من "اتفاقية المستخدم" و"تدابير إدارة المعاملات الكبيرة" مع هذا الدليل. إذا كان المحتوى المحدد في هذا الدليل يتعارض مع قواعد أخرى، فإن هذا الدليل له الأولوية.</strong></p><p><strong>المادة 5:</strong></p><p><strong>المبدأ الأساسي لمكافحة غسيل الأموال في FTZINC هو القيام بأعمال مراقبة مخاطر العملاء وفقًا للمبادئ التالية:</strong></p><p><strong>مبدأ الشمولية. ستنظر منصة FTZINC بشكل شامل في عوامل الخطر المختلفة التي قد يكون العملاء متورطين فيها في غسيل الأموال، وتتبنى أساليب معقولة لمراقبة جميع مخاطر العملاء.</strong></p><p><strong>مبدأ الحيطة والحذر. ستعمل منصة FTZINC على تحسين القدرة على تحديد العملاء على أساس الفهم الكامل للعملاء ومراقبة مخاطر العملاء بحكمة.</strong></p><p><strong>مبدأ الاستدامة. ستستمر منصة FTZINC في الاهتمام بمخاطر العملاء والاستجابة بشكل مناسب وفقًا للوضع الفعلي.</strong></p><p><strong>مبدأ السرية. تعتبر معلومات هوية العميل ومعلومات المعاملة ومعلومات مستوى المخاطر التي تحتفظ بها منصة FTZINC سرية للغاية، ولن يتم تقديمها إلى أي وحدة أو فرد ما لم يكن ذلك متوافقًا مع اللوائح القانونية والمتطلبات التنظيمية.</strong></p><p><strong>مبدأ الإدارة الهرمية. تقوم منصة FTZINC بمراجعة معلومات العميل الأساسية المخزنة بانتظام وفقًا لمستوى مخاطر العميل. يجب أن تكون مراجعة العملاء ذوي مستويات المخاطر الأعلى أكثر صرامة من مراجعة العملاء ذوي مستويات المخاطر الأقل.</strong></p><p><strong>المادة 6:</strong></p><p>تقديم مستندات المستخدم الفردية يجب على مستخدمي FTZINC الفرديين تقديم المعلومات والمواد التالية وفقًا للوائح FTZINC لمكافحة غسيل الأموال:</p><p>اسم شخصي</p><p>وثائق صالحة مثل بطاقة الهوية، وجواز السفر، ورخصة القيادة؛</p><p>المعلومات أو المستندات الأخرى التي يجب تقديمها بناءً على طلب FTZINC.</p><p><strong>المادة 7:</strong></p><p>تقديم وثائق المستخدم المؤسسية يجب على مستخدمي FTZINC المؤسسيين تقديم المعلومات والمواد التالية وفقًا للوائح FTZINC لمكافحة غسيل الأموال:</p><p>اسم الشركة؛</p><p>عنوان المكتب المسجل للشركة؛</p><p>الممثل القانوني للشركة؛</p><p>موطن الممثل القانوني للشركة؛</p><p>رخصة أعمال؛</p><p>نسخة من بطاقة الهوية أو جواز السفر للممثل القانوني للشركة؛</p><p>المعلومات أو المستندات الأخرى التي يجب تقديمها بناءً على طلب FTZINC.</p><p><strong>المادة 8:</strong></p><p>مراجعة وثائق المستخدم. ستقوم منصة FTZINC بالتحقق من المعلومات ذات الصلة المقدمة من العميل وتسجيلها وفقًا لنظام تحديد هوية العميل في لوائح FTZINC لمكافحة غسيل الأموال. في حال كان لدى المنصة أي استفسارات حول المعلومات المقدمة من قبل العميل، يحق لها مراجعة الجهات أو الإدارات المختصة ذات الصلة للتحقق من ذلك.</p><p><strong>المادة 9:</strong></p><p>مراقبة المستخدمين ذوي المخاطر المنخفضة ستعمل منصة FTZINC على اكتشاف المستخدمين ذوي المخاطر المنخفضة وفقًا للمتطلبات المحددة للوائح FTZINC لمكافحة غسيل الأموال. تحتفظ منصة FTZINC بالحق في تعديل مستوى المستخدمين ذوي المخاطر المنخفضة.</p><p><strong>المادة 10:</strong></p><p>مراقبة المستخدمين ذوي المخاطر العالية ستقوم منصة FTZINC بمراجعة العملاء ذوي المخاطر العالية كل ستة أشهر لتحديث المعلومات الأساسية لهوية العميل والتعرف على مصدر الأموال أو استخدام الأموال أو الظروف الاقتصادية أو ظروف التشغيل.</p><p><strong>المادة 11:</strong></p><p>الحفاظ على ملفات المستخدم ستتخذ منصة FTZINC التدابير اللازمة وفقًا للقانون لتخزين بيانات هوية العميل ومعلومات المعاملات لفترة زمنية معينة. بالإشارة إلى القواعد المقبولة دوليًا، يجب الاحتفاظ بمعلومات هوية المستخدم لمدة خمس سنوات على الأقل بعد انتهاء علاقة العمل ومعلومات معاملة العميل بعد انتهاء المعاملة.</p><p><strong>المادة 12:</strong></p><p>انتباه المستخدم يجب على مستخدمي FTZINC الانتباه إلى الأمور التالية: يمنع إعارة حساب المستخدم الخاص للآخرين؛</p><p>يحظر استئجار أو إعارة شهادة هوية المستخدم؛</p><p>يُحظر استئجار أو إقراض أو الكشف عن حساب المستخدم الخاص أو البطاقة المصرفية أو دفتر المرور أو كلمة المرور وغيرها من معلومات الملكية الشخصية المهمة؛</p><p>يجب على المستخدمين التعاون بشكل نشط مع منصة FTZINC لتحديد هوية العميل؛</p><p>عند التداول على منصة FTZINC، حدد واستخدم مؤسسات مالية خارجية آمنة وموثوقة لأنشطة الدفع.</p><p><strong>المادة 13:</strong></p><p>الإبلاغ عن السلوك المشبوه إذا اكتشف مستخدم منصة FTZINC أن أي حساب قد يكون متورطًا في أنشطة غسيل الأموال أو تمويل الإرهاب أثناء معاملات المنصة، فيمكن للمستخدم الإبلاغ إلى منصة FTZINC.</p><p><strong>المادة 14:</strong></p><p>تفسير الإرشادات يتم تفسير هذا الدليل بواسطة منصة FTZINC.</p><p><strong>المادة 15:</strong></p><p>فترة السريان: سيتم تنفيذ الإرشادات اعتبارًا من تاريخ إصدارها.</p>`,

  tradeMin100: 'الحد الأدنى لمبلغ التداول: 100 دولار أمريكي',
  cancelled: 'ألغيت',

  phone: 'الهاتف (اختياري)',
  phone1: 'الهاتف ',

  toTrade: 'استبدل الان',

  openRecord: 'افتح السجل',
  closeRecord: 'إغلاق السجل',

  closeOrder: 'إغلاق الأمر',


  swiperTitle2: 'منصة التشفير الكل في واحد الخاصة بك لشراء وبيع وتداول وحيازة وكسب العملات المشفرة.',
  swiperSub2: 'لقد قمنا بإرشاد الملايين من المستخدمين حول العالم في رحلة أصولهم الرقمية.',

  homeremind31: 'شراء العملة المشفرة',
  homeremind32: 'انت تدفع',
  homeremind33: 'لقد حصلت',
  homeremind34: 'سيتم إعادة حساب السعر في',
  homeremind35: 'الأحكام والشروط',
  homeremind36: 'اشتري الآن',
  homeremind37: 'FTZINC عبارة عن منصة من خطوة واحدة للجميع',
  homeremind38: 'العملاء',
  homeremind39: 'البلدان المدعومة',
  homeremind40: 'حجم التداول ربع السنوي',

  homeremind41: 'كيف تبدأ',
  homeremind42: 'إنشاء حساب',
  homeremind43: 'قم بتسجيل الدخول إلى FTZINC لتسجيل ملف تعريف جديد.',
  homeremind44: 'تحقق من هويتك',
  homeremind45: 'اقضِ أقل من 5 دقائق في إكمال عملية التحقق.',
  homeremind46: 'أنشئ حسابك أولاً',
  homeremind47: 'شراء وإيداع التشفير',
  homeremind48: 'قم بإضافة أموال إلى حساب FTZINC الخاص بك للوصول إلى خدمات العملة المشفرة.',
  homeremind49: 'تحقق من هويتك أولاً',
  homeremind50: 'ابدأ رحلتك',


  homeremind51: 'استكشف فرص التشفير ضمن نظام FTZINC البيئي.',
  homeremind52: 'قم بشراء وإيداع العملة المشفرة أولاً',
  homeremind53: 'قم ببناء محفظة العملات المشفرة الخاصة بك',
  homeremind54: 'شراء التشفير',
  homeremind55: 'لماذا تختار FTZINC؟',
  homeremind56: 'بساطة',
  homeremind57: 'تسهل FTZINC شراء العملات المشفرة باستخدام تطبيق الهاتف المحمول الخاص بنا.',
  homeremind58: 'تعليم',
  homeremind59: 'لست متأكدا من أين تبدأ؟ توجه إلى مركز التعلم الخاص بنا وتعرف على كل ما يتعلق بالعملات المشفرة.',

  homeremind60: 'خدمة',
  homeremind61: 'اعثر على إجاباتك فورًا في مركز الدعم لدينا. أو تواصل معنا 24/7/365 عبر البريد الإلكتروني.',
  homeremind62: 'ابدأ مع FTZINC',
  homeremind63: 'لغة',

  signin: 'تسجيل الدخول',



  ieointro1: `الفريق المؤسس`,
  ieointro2: `صندوق الاستثمار الملائكي`,
  ieointro3: `النظام البيئي`,
  ieointro4: `مرحلة ما قبل البيع`,
  ieointro5: `التعدين`,


  ieointro10: `الفريق المؤسس`,
  ieointro11: `صندوق المستثمرين الملائكيين`,
  ieointro12: `النظام البيئي`,
  ieointro13: `تخصيص ما قبل البيع`,
  ieointro14: `مكافآت التعدين`,


  personalInfo: 'معلومات شخصية',
  modifyPassword: 'تعديل كلمة المرور',



  swiperTitle3: 'ابحث عن الجيل القادم',
  swiperTitle4: 'تداول العملات المشفرة على FTZINC',
  swiperTitle5: `تبادل التشفير {'|'} التداول بالهامش {'|'} مشتقات التشفير`,

  homeremind64: 'أفتح حساب الأن',
  homeremind65: 'البلدان المشمولة',
  homeremind66: 'المستثمرين العالميين',
  homeremind67: 'العملات المشفرة',
  homeremind68: 'حجم التداول على مدار 24 ساعة',

  homeremind69: 'Scan QR Code to Download App',//No need
  homeremind70: 'عنوان البريد الإلكتروني',

  homeremind71: 'البيع المسبق للعملات المشفرة الجديدة',
  homeremind72: 'View all 700+ coins', //No need

  homeremind73: 'Coming Soon',//No need
  homeremind74: 'يشترك',

  homeremind75: 'القائمة الساخنة',
  homeremind76: 'قائمة الرابح',
  homeremind77: 'قائمة الخاسرين',

  homeremind78: 'جرب بورصة العملات المشفرة الرائدة عالميًا الآن',
  homeremind79: `السلامة {'|'} لا رسوم {'|'} سريع {'|'} اللامركزية`,
  homeremind80: 'View more benefits',//No need
  homeremind81: 'خطوة واحدة فقط للتسجيل باستخدام عنوان البريد الإلكتروني والتداول الآن',


  homeremind82: 'اكتشف منتجات وخدمات FTZINC',
  homeremind83: 'التداول الفوري',
  homeremind84: 'تداول العملات المشفرة باستخدام مجموعتنا الشاملة من الأدوات القوية لتحقيق أقصى قدر من أرباحك.',
  homeremind85: 'شراء التشفير',
  homeremind86: 'قم بشراء العملات المشفرة بسرعة وسهولة على منصتنا المشهورة والرائدة في الصناعة.',
  homeremind87: 'مشتقات التشفير',
  homeremind88: 'نحن أفضل بورصة عملات مشفرة لتداول عقود العملات المشفرة الآجلة.',
  homeremind89: 'FTZINC Earn',//No need
  homeremind90: 'Invest and earn steady income with the help of a professional asset manager.',//No need
  homeremind91: 'Trading Bot',//No need
  homeremind92: 'Earn passive income round-the-clock without having to constantly monitor markets.',//No need
  homeremind93: 'التداول بالهامش',
  homeremind94: 'استفد من أصولك من خلال التداول بالهامش.',
  homeremind95: 'Leveraged Tokens',//No need
  homeremind96: 'Amplify your investment returns by simply buying and selling leveraged tokens.',//No need
  homeremind97: 'Halo Wallet',//No need
  homeremind98: 'A self-custody social wallet that allows you to easily discover, invest, and earn.',//No need

  homeremind99: 'تبادل العملات المشفرة الآمن والموثوق به',
  homeremind100: 'تخزين الأصول الآمنة',
  homeremind101: 'تضمن أنظمة التشفير والتخزين الرائدة في الصناعة لدينا أن أصولك آمنة ومأمونة دائمًا.',
  homeremind102: 'أمان حساب قوي',
  homeremind103: 'نحن نلتزم بأعلى معايير الأمان وننفذ ممارسات الأمان الأكثر صرامة للحفاظ على أمان حسابك.',
  homeremind104: 'منصة موثوقة',
  homeremind105: 'لدينا أساس ذو تصميم آمن لضمان الاكتشاف السريع والاستجابة لأي هجمات إلكترونية.',
  homeremind106: 'PoR - شفافية الأصول',
  homeremind107: 'يُعد إثبات الاحتياطيات (PoR) طريقة مستخدمة على نطاق واسع لإثبات حراسة الأصول على سلسلة الكتل، مما يؤكد أن FTZINC لديها الأموال التي تغطي جميع أصول المستخدم في دفاترنا.',

  homeremind108: 'Learn More',//No need
  homeremind109: 'التجارة في أي وقت وفي أي مكان',
  homeremind110: 'يتيح لك تطبيق وموقع FTZINC تداول العملات المشفرة بسهولة.',
  
  
  homeremind111: 'خدمة العملاء 24/7',
  homeremind112: 'أسئلتك، أجاب. تواصل مع دعم عملاء FTZINC لطرح أسئلتك في أي وقت.',
  homeremind113: 'FTZINC Help Center',//No need
  homeremind114: 'انضم إلى مجتمعنا',
  homeremind115: 'يعد مجتمع FTZINC العالمي موطنًا لملايين المستخدمين من أكثر من 100 دولة، مع دعم لأكثر من 20 لغة.',
  homeremind116: 'المجتمع الإنجليزي',
  homeremind117: 'View all 20+ languages',//No need
  homeremind118: 'FTZINC بجانبك',
  homeremind119: 'ابدأ رحلتك المشفرة الآن!',
  
  appDownload: 'تحميل التطبيق',
  androidDownload: 'تحميل اندرويد',
  iosDownload: 'تحميل دائرة الرقابة الداخلية',

  funding: 'التمويل',



  withdrawTip4: `سيتم خصم رسوم خدمة قدرها`,
  withdrawTip5: `لكل طلب سحب، وسيتم خصم`, 
  withdrawTip6: `فقط لأي مبلغ سحب.`,  

  assetsManagement: 'إدارة الأصول',
  myAssets: 'أصولي',


  homeremind194: `ابدأ في 30 ثانية!`,

  homeremind195: `إنشاء حساب`,
  homeremind196: `أدخل عنوان بريدك الإلكتروني وتحقق من صندوق الوارد لديك للحصول على رمز التحقق المكون من 5 أرقام. ما عليك سوى إدخال الرمز في صفحة التحقق لإكمال عملية التسجيل.`,
  homeremind197: `قم بالإيداع`,
  homeremind198: `قم بتمويل حسابك بسهولة على FTZINC Web أو App.`,
  homeremind199: `ابدأ التداول`,
  homeremind200: `ابدأ رحلتك مع أزواج العملات المفضلة لديك أو عقود العقود الآجلة!`,



  homeremind139: 'مسح رمز الاستجابة السريعة',
  homeremind140: 'قم بتنزيل تطبيق FTZINC لنظام Android / iOS',


  homeremind120: 'عملة جديدة ما قبل البيع',
  homeremind121: `وقعت Encryption Open AI اتفاقيات إدراج حصرية مع MEXC Global وHuobi وBybit، وهي بورصات العملات الرقمية الرائدة في العالم، مما يشير إلى أن رموز EO قد تم الاعتراف بها وقبولها على نطاق واسع في السوق. مع استمرار إدراج رموز EO وتعميمها في أفضل البورصات حول العالم، سيتم توسيع شعبيتها وتأثيرها بشكل أكبر، مما يوفر زخمًا أقوى لتطوير Encryption Open AI.`,
  homeremind122: 'Encryption Open AI',
  homeremind123: 'سعر الإصدار',
  homeremind124: 'تاريخ البدء',
  homeremind125: 'منتهي الصلاحية',
  homeremind126: 'يشترك',
  homeremind127: 'مشتركين',
  homeremind128: 'مشترك',
  homeremind129: 'ينتهي في',
  homeremind130: 'أيام',



  ieoIntro: 'مقدمة الرمز',
  homeSentence1: `خدمات 7*24`,
  homeSentence2: `العمل بدوام كامل`,
  homeSentence3: `لتلبية كافة احتياجات التداول`,
  homeSentence4: `التداول في أي وقت وفي أي مكان`,


  check: 'يفحص',

  commodities: 'السلع الأساسية',





  

  forgotPassword: `هل نسيت كلمة السر؟`,
  registerText: `ليس لديك حساب؟`,
  registerText1: `سجل هنا`,

  loginText: `قم بتسجيل الدخول إلى حسابك`,
  loginText1: `هل لديك حساب؟`,
  loginText2: `سجل دخولك هنا`,

  loginPolicy: `بالتسجيل، أوافق على شروط الخدمة ومعالجة بياناتي الشخصية كما هو موضح في سياسة الخصوصية.`,
  registerPolicy: `بتسجيل الدخول، أوافق على شروط الخدمة ومعالجة بياناتي الشخصية كما هو موضح في سياسة الخصوصية.`,

  loginLayoutText: `موثوق به من قبل أكثر من 1.5 مليون مستخدم حول العالم. جاهز عندما تكون أنت جاهزاً.`,

  homeSwiperTitle: `تداول العملات الفورية، والتداول بالهامش، والعقود الآجلة، والتداول خارج البورصة على أفضل منصة لتداول العملات الرقمية`,
  homeSwiperText: `التداول الاحترافي، للجميع.`,

  startTrading: 'ابدأ التداول',
  exploreMarkets: 'استكشف الأسواق',

  downloadOn: `قم بالتنزيل`,
  getItOn: `ابدأ به`,

  homeCoinListSentence: `للمبتدئين والمتداولين المحترفين`,
  homeCoinListSentence1: `شراء وبيع وإدارة`,
  homeCoinListSentence2: `أكثر من 100 أصل من الأصول الرقمية`,
  homeCoinListSentence3: `استكشف جميع الأصول الرقمية`,

  homeWhyChooseSentence: `لماذا عملة FTZINC؟`,
  homeWhyChooseSentence1: `منصة تداول العملات الرقمية المفضلة لأكثر من 1.5 مليون مستخدم حول العالم`,
  //homeWhyChooseSentence2: `more than 1.5 million users globally`,
  homeWhyChooseSentence3: `الأسواق الفعالة`,
  homeWhyChooseSentence4: `تداول أكثر من 100 أصل من الأصول المشفرة عبر أسواق FTZINC السائلة للتداول الفوري، والتداول الفوري بالهامش، والعقود الآجلة الدائمة، والمجهزة بمجموعة من أنواع الأوامر وأدوات التداول.`,
  homeWhyChooseSentence5: `منتجات ذات إنتاجية مرنة`,
  homeWhyChooseSentence6: `حقق عوائد مجزية من خلال حلول التخزين السائل سهلة الاستخدام لدينا، حيث نتولى عنك تعقيدات التخزين عبر الإنترنت.`,
  homeWhyChooseSentence7: `واجهة برمجة تطبيقات عالمية المستوى`,
  homeWhyChooseSentence8: `توفر واجهة برمجة التطبيقات (API) الخاصة بنا، والمخصصة للمؤسسات، بيانات السوق في الوقت الفعلي والتاريخية، والحسابات المشتركة، وحدود أسعار تنافسية للغاية.`,
  homeWhyChooseSentence9: `تحويل العملات بسهولة`,
  homeWhyChooseSentence10: `يمكنك بسهولة تحويل العملات المختلفة إلى عملات مشفرة من خلال منصة التبادل البسيطة للشراء والبيع الخاصة بنا، أو عن طريق التحويل المصرفي، أو منصة التداول خارج البورصة.`,
  homeWhyChooseSentence11: `خدمة العملاء`,
  homeWhyChooseSentence12: `نقوم بتخصيص خدماتنا لتلبية احتياجات عملائنا، ونقدم دعمًا سريعًا ومفيدًا للعملاء، وقنوات دعم خاصة لشركائنا من الشركات.`,
  homeWhyChooseSentence13: `عملية انضمام سريعة`,
  homeWhyChooseSentence14: `بفضل امتثالنا الكامل لمتطلبات اعرف عميلك ومكافحة غسل الأموال، ومع أعلى درجات الاهتمام بخصوصية البيانات، يمكن إكمال عملية التسجيل الآلية الخاصة بنا في دقائق.`,

  homeQuicklyStartSentence: `ابدأ التداول بسرعة`,
  homeQuicklyStartSentence1: `ابدأ في دقائق`,
  //homeQuicklyStartSentence2: `in minutes`,
  homeQuicklyStartSentence3: `افتح حسابًا`,
  homeQuicklyStartSentence4: `أنشئ حسابك وقم بتفعيله في دقائق`,
  homeQuicklyStartSentence5: `قم بتمويل حسابك`,
  homeQuicklyStartSentence6: `قم بإيداع العملات الورقية عن طريق التحويل المصرفي أو قم بإيداع العملات الرقمية مباشرة لتمويل حسابك`,
  homeQuicklyStartSentence7: `ابدأ التداول`,
  homeQuicklyStartSentence8: `تداول أكثر من 100 أصل من الأصول الرقمية عبر التداول الفوري، والتداول الفوري بالهامش، والعقود الآجلة، أو قم بالتكامل مع واجهة برمجة التطبيقات القوية الخاصة بنا لتحقيق أقصى استفادة من عمليات التداول الخاصة بك.`,

  homeGetStartSentence: `التداول الاحترافي،`,
  homeGetStartSentence1: `للجميع.`,
  homeGetStartSentence2: `ابدأ الآن`,

  homeOurInvestorsSentence: `مستثمرينا`,



  favorites: 'المفضلة',
  original: 'إبداعي',


  indices: `المؤشرات`,
  indicesNotAllowOpen: `لا يُسمح بفتح الصفقات أثناء إغلاق السوق`,
  indicesNotAllowClose: `لا يُسمح بإغلاق الصفقات أثناء إغلاق السوق`,
  indicesNotAllowSet: `لا يُسمح بتعديل الأوامر أثناء إغلاق السوق`,



  tokenIntroduction: `مقدمة عن الرموز`,
  newWhitepaper: `الورقة البيضاء`,


  kbfIntro1: `مزرعة فراشات كنتاكي (KBF)، التي تقودها شركة Quantum Asset Management Pte Ltd ومقرها سنغافورة، هي منصة بلوك تشين عامة رائدة تعتمد على آلية صانع السوق المحاسبي العالمي (AMM) لتداول الأصول. بُنيت هذه المنصة على آلية صانع السوق المحاسبي العالمي (AMM)، وألعاب البلوك تشين، وبنية تحتية اجتماعية، وتعمل كنظام حوسبة فائقة للتطبيقات التجارية، مما يتيح النشر السريع لخدمات متنوعة تشمل AMM وGameFi وSocialFi.`,
  kbfIntro2: `تُظهر تقنية شبكة بلوك تشين العامة لمزرعة فراشات كنتاكي (KBF) مزايا متعددة. أبرزها الأداء العالي، مما يُمكّنها من معالجة المزيد من المعاملات وتحقيق أوقات تأكيد أسرع. في قطاع التمويل الرقمي، تُعد السرعة والكفاءة من أهم معايير تقييم جودة الخدمة. من خلال التحسين المستمر لبنيتها التقنية، نجحت مزرعة فراشات كنتاكي (KBF) في تعزيز قدرات معالجة المعاملات، مما يوفر للمستخدمين تجارب خدمات مالية أسرع وأكثر كفاءة.`,
  kbfIntro3: `ثانيًا، تُظهر مزرعة فراشات كنتاكي (KBF) قابلية توسع استثنائية. مع النمو السريع للأسواق المالية الرقمية، تستمر قاعدة المستخدمين ومتطلبات التطبيقات في التوسع. استجابةً لهذا الطلب المتزايد، صُممت سلسلة كتل KBF مع مراعاة قابلية التوسع المستقبلي للشبكة منذ البداية. وبفضل استخدام تقنيات صناعة السوق الآلية (AMM) وإثبات المعرفة الصفرية، تتعامل السلسلة بسلاسة مع الزيادات المفاجئة في حركة مرور المستخدمين وأحجام المعاملات، مما يضمن استقرار عمليات الشبكة وتطورها المستدام.`,
  code: `رمز التحقق`,
  codeInput: `يرجى إدخال رمز التحقق`,

  homepage: {
    hero: {
      title: `العصر القادم`,
      titleWeb3: `من Web3.`,
      highlight: `مصمم لـ`,
      everyone: `الجميع.`,
      description: `FTZINC هو نظام Web3 متكامل للتداول والكسب واللعب والبناء—ببساطة وأمان ومتعة حقيقية.`,
      launchApp: `تشغيل التطبيق`,
      exploreEcosystem: `استكشف النظام البيئي`,
      statsAriaLabel: `FTZINC في لمحة`,
      stats: {
        happyUsers: `مستخدمون سعداء`,
        tvlLocked: `إجمالي القيمة المقفلة`,
        transactions: `المعاملات`,
        countries: `الدول`,
      },
      imageAlt: `تطبيق FTZINC ورموز العملات المشفرة وتميمة روبوت ودودة`,
    },
    market: {
      title: `استكشف أصول العملات المشفرة`,
      description: `تابع الأسعار المباشرة، واكتشف الأصول المتحركة، واعثر على فرصتك التالية.`,
      view: `عرض السوق`,
      tabs: {
        popular: `الأكثر شيوعًا`,
        gainers: `الأكثر ارتفاعًا`,
        losers: `الأكثر انخفاضًا`,
      },
      viewAll: `عرض جميع الأسواق`,
      itemAria: `{name}، {price} USDT، {change} خلال 24 ساعة`,
      noPriceChanges: `لا توجد تغيّرات في الأسعار لعرضها بعد. جرّب عرضًا آخر.`,
      dataPending: `ستظهر بيانات السوق عند الاتصال بالأسعار.`,
    },
    features: {
      sectionTitle: `استكشف منظومة FTZINC`,
      trade: {
        title: `تداول بسلاسة`,
        description: `بدّل الرموز عبر سلاسل متعددة برسوم منخفضة وأفضل الأسعار.`,
      },
      earn: {
        title: `اكسب المكافآت`,
        description: `ارهن وزرع واكسب دخلًا سلبيًا مع FTZINC.`,
      },
      play: {
        title: `استكشف والعب`,
        description: `ألعاب ومهام Web3 ممتعة. العب واكسب وتقدّم!`,
      },
      build: {
        title: `ابنِ وانشر`,
        description: `أدوات وبنية تحتية لبناء المستقبل على FTZINC.`,
      },
      secure: {
        title: `آمن وبسيط`,
        description: `أمان من الطراز الأول مع تجربة مستخدم مصممة للجميع.`,
      },
    },
    ecosystem: {
      title: `منظومة FTZINC`,
      allProducts: `جميع المنتجات`,
      products: {
        wallet: {
          title: `محفظة FTZINC`,
          description: `بوابتك إلى Web3.`,
        },
        swap: {
          title: `مبادلة FTZINC`,
          description: `مبادلات بين السلاسل أصبحت سهلة.`,
        },
        earn: {
          title: `كسب FTZINC`,
          description: `ضاعف أرباحك من العملات المشفرة.`,
        },
        launchpad: {
          title: `منصة إطلاق FTZINC`,
          description: `اكتشف وأطلق المشاريع الكبيرة القادمة.`,
        },
        commodities: {
          title: `FTZINC السلع الأساسية`,
          description: `استكشف أسواق الطاقة والمعادن وغيرها من السلع العالمية.`,
        },
        indices: {
          title: `FTZINC المؤشرات`,
          description: `تابع مؤشرات الأسواق الرئيسية وتداول بثقة.`,
        },
      },
    },
    pocket: {
      title: `قوة FTZINC`,
      titleLine2: `في جيبك`,
      description: `أدر Web3 وتداول واستكشفه في أي وقت ومن أي مكان.`,
      imageAlt: `محفظة FTZINC وتجارب المبادلة والمهام على الهاتف المحمول`,
    },
    learn: {
      title: `تعلّم وتطوّر وابقَ في المقدمة.`,
      viewAll: `عرض جميع المقالات`,
      articles: {
        web3: {
          category: `أساسيات`,
          title: `ما هو Web3؟`,
          description: `دليل المبتدئين إلى مستقبل الإنترنت.`,
        },
        stake: {
          category: `أدلة`,
          title: `كيفية تكديس NEX`,
          description: `دليل خطوة بخطوة لبدء الكسب مع FTZINC.`,
        },
        security: {
          category: `الأمان`,
          title: `ابقَ آمنًا في Web3`,
          description: `نصائح أساسية لحماية أصولك.`,
        },
        chain: {
          category: `النظام البيئي`,
          title: `شرح سلسلة FTZINC`,
          description: `مصممة للسرعة والتوسع والمستقبل.`,
        },
      },
    },
    voices: {
      title: `آراء المجتمع`,
      chris: `FTZINC يجعل Web3 بسيطًا وممتعًا. الواجهة واضحة والفريق رائع.`,
      diana: `جرّبت منصات كثيرة، لكن FTZINC مميز فعلًا. سريع وآمن وسهل.`,
      wolf: `تضم المنظومة كل ما أحتاجه في مكان واحد. أحبها!`,
      mia: `ألعاب FTZINC إدمانية. الكسب أثناء الاستمتاع هو الأفضل.`,
      dan: `كان البناء على سلسلة FTZINC سلسًا جدًا. أدوات ودعم رائعان!`,
    },
    newsletter: {
      title: `كن أول من يعرف.`,
      description: `احصل على تحديثات المنتجات ورؤى Web3 والوصول المبكر من FTZINC.`,
      emailLabel: `عنوان البريد الإلكتروني`,
      emailPlaceholder: `أدخل بريدك الإلكتروني`,
      createAccount: `إنشاء حساب`,
    },
  },
}
